/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserMaster = /* GraphQL */ `
  mutation CreateUserMaster(
    $input: CreateUserMasterInput!
    $condition: ModelUserMasterConditionInput
  ) {
    createUserMaster(input: $input, condition: $condition) {
      email
      id
      isParent
      showPopup
      registerBy
      password
      status
      myfeedTour
      profileTour
      cvTour
      projectTour
      disabled
      registeredDate
      UserProfileDetails {
        items {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        nextToken
        __typename
      }
      auth_method
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserMaster = /* GraphQL */ `
  mutation UpdateUserMaster(
    $input: UpdateUserMasterInput!
    $condition: ModelUserMasterConditionInput
  ) {
    updateUserMaster(input: $input, condition: $condition) {
      email
      id
      isParent
      showPopup
      registerBy
      password
      status
      myfeedTour
      profileTour
      cvTour
      projectTour
      disabled
      registeredDate
      UserProfileDetails {
        items {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        nextToken
        __typename
      }
      auth_method
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserMaster = /* GraphQL */ `
  mutation DeleteUserMaster(
    $input: DeleteUserMasterInput!
    $condition: ModelUserMasterConditionInput
  ) {
    deleteUserMaster(input: $input, condition: $condition) {
      email
      id
      isParent
      showPopup
      registerBy
      password
      status
      myfeedTour
      profileTour
      cvTour
      projectTour
      disabled
      registeredDate
      UserProfileDetails {
        items {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        nextToken
        __typename
      }
      auth_method
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserProfileDetails = /* GraphQL */ `
  mutation CreateUserProfileDetails(
    $input: CreateUserProfileDetailsInput!
    $condition: ModelUserProfileDetailsConditionInput
  ) {
    createUserProfileDetails(input: $input, condition: $condition) {
      userID {
        email
        id
        isParent
        showPopup
        registerBy
        password
        status
        myfeedTour
        profileTour
        cvTour
        projectTour
        disabled
        registeredDate
        UserProfileDetails {
          nextToken
          __typename
        }
        auth_method
        createdAt
        updatedAt
        __typename
      }
      about_me
      about_restriction
      bg_image
      career_goal
      city
      cnt_views
      cv_data
      country
      cvs
      dob
      first_name
      gender
      id
      job
      languages
      last_name
      links
      loginAt
      middle_name
      mobile_no
      parent_email
      parent_mobile
      parent_name
      profile_avatar
      profile_complition
      profile_image
      projects
      projects_data
      referralCode
      school_name
      accomplishment_data
      connection_data
      skipMobileVerification
      skipParentalconsent
      isMobileVerified
      isParentVerified
      isSelfEmailVerified
      isparentRequestSent
      mobileSmsTriggerCnt
      selfEmailTriggerCnt
      parentRequestSentTriggerCnt
      welcomeEmailSentCnt
      mobileSmsTriggerDt
      selfEmailTriggerDt
      parentRequestSentTriggerDt
      welcomeEmailSentDt
      mobileReminderSmsTriggerCnt
      mobileReminderSmsTriggerDt
      mobileCountrycode
      parentmobileCountrycode
      isTestUser
      source
      isAdmin
      adminSchoolName
      adminCompanyName
      adminIssuingOrganisation
      adminAccomplishmentsProvider
      adminMembershipOrganisation
      adminLogo
      state
      tblrolemappingID
      userProfileDetailsUserMasterId
      userType
      username
      UserCards {
        items {
          id
          restricted
          status
          title
          type
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCardsId
          __typename
        }
        nextToken
        __typename
      }
      UserCvs {
        items {
          cv_title
          description
          id
          link
          password
          restricted
          status
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCvsId
          __typename
        }
        nextToken
        __typename
      }
      connections {
        items {
          id
          userProfileDetailsId
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      notifications {
        items {
          id
          action
          content
          delete
          read
          subject
          turnoffsimilar
          createdAt
          updatedAt
          userProfileDetailsNotificationsId
          __typename
        }
        nextToken
        __typename
      }
      userActivity {
        items {
          id
          cartItem_id
          status
          type
          data
          createdAt
          updatedAt
          userProfileDetailsUserActivityId
          __typename
        }
        nextToken
        __typename
      }
      posts {
        items {
          id
          rootPostId
          refrencePostId
          cardItemID
          postType
          createdAt
          updatedAt
          userProfileDetailsPostsId
          __typename
        }
        nextToken
        __typename
      }
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentsId
          postsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      CommentOne {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentOneId
          commentsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      likes {
        items {
          id
          status
          createdAt
          updatedAt
          userProfileDetailsLikesId
          postsLikesId
          __typename
        }
        nextToken
        __typename
      }
      views {
        items {
          id
          ipAddress
          status
          createdAt
          updatedAt
          userProfileDetailsViewsId
          postsViewsId
          __typename
        }
        nextToken
        __typename
      }
      quizResults {
        items {
          id
          iSpringID
          quizCategory
          quizLevel
          quizTitle
          quizGrade
          quizSeqNo
          totalScore
          quizScore
          status
          createdAt
          updatedAt
          userProfileDetailsQuizResultsId
          postsQuizResultsId
          __typename
        }
        nextToken
        __typename
      }
      registeredDate
      adminSchoolType
      quizAvgScore
      interests {
        items {
          id
          userInterestID
          interestID
          createdAt
          updatedAt
          userProfileDetailsInterestsId
          interestUsersId
          __typename
        }
        nextToken
        __typename
      }
      subinterests {
        items {
          id
          userInterestID
          subinterestID
          createdAt
          updatedAt
          userProfileDetailsSubinterestsId
          subinterestUsersId
          __typename
        }
        nextToken
        __typename
      }
      quizStudent {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          userProfileDetailsQuizStudentId
          quizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      moduleStudentQuestionResult {
        items {
          id
          iSpringID
          moduleCategory
          moduleLevel
          moduleTitle
          moduleGrade
          moduleSeqNo
          questionIndex
          questionText
          totalScore
          schoolName
          schoolLocation
          userAnswer
          creatorEmail
          Status
          correctAnswer
          pointsAllotted
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsModuleStudentQuestionResultId
          postsStudentModuleQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      connectedInstituteAdmins
      connectionsCount
      portfolioCount
      blogCount
      diaryCount
      cvCount
      mystuffCount
      createdAt
      updatedAt
      userMasterUserProfileDetailsId
      __typename
    }
  }
`;
export const updateUserProfileDetails = /* GraphQL */ `
  mutation UpdateUserProfileDetails(
    $input: UpdateUserProfileDetailsInput!
    $condition: ModelUserProfileDetailsConditionInput
  ) {
    updateUserProfileDetails(input: $input, condition: $condition) {
      userID {
        email
        id
        isParent
        showPopup
        registerBy
        password
        status
        myfeedTour
        profileTour
        cvTour
        projectTour
        disabled
        registeredDate
        UserProfileDetails {
          nextToken
          __typename
        }
        auth_method
        createdAt
        updatedAt
        __typename
      }
      about_me
      about_restriction
      bg_image
      career_goal
      city
      cnt_views
      cv_data
      country
      cvs
      dob
      first_name
      gender
      id
      job
      languages
      last_name
      links
      loginAt
      middle_name
      mobile_no
      parent_email
      parent_mobile
      parent_name
      profile_avatar
      profile_complition
      profile_image
      projects
      projects_data
      referralCode
      school_name
      accomplishment_data
      connection_data
      skipMobileVerification
      skipParentalconsent
      isMobileVerified
      isParentVerified
      isSelfEmailVerified
      isparentRequestSent
      mobileSmsTriggerCnt
      selfEmailTriggerCnt
      parentRequestSentTriggerCnt
      welcomeEmailSentCnt
      mobileSmsTriggerDt
      selfEmailTriggerDt
      parentRequestSentTriggerDt
      welcomeEmailSentDt
      mobileReminderSmsTriggerCnt
      mobileReminderSmsTriggerDt
      mobileCountrycode
      parentmobileCountrycode
      isTestUser
      source
      isAdmin
      adminSchoolName
      adminCompanyName
      adminIssuingOrganisation
      adminAccomplishmentsProvider
      adminMembershipOrganisation
      adminLogo
      state
      tblrolemappingID
      userProfileDetailsUserMasterId
      userType
      username
      UserCards {
        items {
          id
          restricted
          status
          title
          type
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCardsId
          __typename
        }
        nextToken
        __typename
      }
      UserCvs {
        items {
          cv_title
          description
          id
          link
          password
          restricted
          status
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCvsId
          __typename
        }
        nextToken
        __typename
      }
      connections {
        items {
          id
          userProfileDetailsId
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      notifications {
        items {
          id
          action
          content
          delete
          read
          subject
          turnoffsimilar
          createdAt
          updatedAt
          userProfileDetailsNotificationsId
          __typename
        }
        nextToken
        __typename
      }
      userActivity {
        items {
          id
          cartItem_id
          status
          type
          data
          createdAt
          updatedAt
          userProfileDetailsUserActivityId
          __typename
        }
        nextToken
        __typename
      }
      posts {
        items {
          id
          rootPostId
          refrencePostId
          cardItemID
          postType
          createdAt
          updatedAt
          userProfileDetailsPostsId
          __typename
        }
        nextToken
        __typename
      }
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentsId
          postsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      CommentOne {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentOneId
          commentsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      likes {
        items {
          id
          status
          createdAt
          updatedAt
          userProfileDetailsLikesId
          postsLikesId
          __typename
        }
        nextToken
        __typename
      }
      views {
        items {
          id
          ipAddress
          status
          createdAt
          updatedAt
          userProfileDetailsViewsId
          postsViewsId
          __typename
        }
        nextToken
        __typename
      }
      quizResults {
        items {
          id
          iSpringID
          quizCategory
          quizLevel
          quizTitle
          quizGrade
          quizSeqNo
          totalScore
          quizScore
          status
          createdAt
          updatedAt
          userProfileDetailsQuizResultsId
          postsQuizResultsId
          __typename
        }
        nextToken
        __typename
      }
      registeredDate
      adminSchoolType
      quizAvgScore
      interests {
        items {
          id
          userInterestID
          interestID
          createdAt
          updatedAt
          userProfileDetailsInterestsId
          interestUsersId
          __typename
        }
        nextToken
        __typename
      }
      subinterests {
        items {
          id
          userInterestID
          subinterestID
          createdAt
          updatedAt
          userProfileDetailsSubinterestsId
          subinterestUsersId
          __typename
        }
        nextToken
        __typename
      }
      quizStudent {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          userProfileDetailsQuizStudentId
          quizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      moduleStudentQuestionResult {
        items {
          id
          iSpringID
          moduleCategory
          moduleLevel
          moduleTitle
          moduleGrade
          moduleSeqNo
          questionIndex
          questionText
          totalScore
          schoolName
          schoolLocation
          userAnswer
          creatorEmail
          Status
          correctAnswer
          pointsAllotted
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsModuleStudentQuestionResultId
          postsStudentModuleQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      connectedInstituteAdmins
      connectionsCount
      portfolioCount
      blogCount
      diaryCount
      cvCount
      mystuffCount
      createdAt
      updatedAt
      userMasterUserProfileDetailsId
      __typename
    }
  }
`;
export const deleteUserProfileDetails = /* GraphQL */ `
  mutation DeleteUserProfileDetails(
    $input: DeleteUserProfileDetailsInput!
    $condition: ModelUserProfileDetailsConditionInput
  ) {
    deleteUserProfileDetails(input: $input, condition: $condition) {
      userID {
        email
        id
        isParent
        showPopup
        registerBy
        password
        status
        myfeedTour
        profileTour
        cvTour
        projectTour
        disabled
        registeredDate
        UserProfileDetails {
          nextToken
          __typename
        }
        auth_method
        createdAt
        updatedAt
        __typename
      }
      about_me
      about_restriction
      bg_image
      career_goal
      city
      cnt_views
      cv_data
      country
      cvs
      dob
      first_name
      gender
      id
      job
      languages
      last_name
      links
      loginAt
      middle_name
      mobile_no
      parent_email
      parent_mobile
      parent_name
      profile_avatar
      profile_complition
      profile_image
      projects
      projects_data
      referralCode
      school_name
      accomplishment_data
      connection_data
      skipMobileVerification
      skipParentalconsent
      isMobileVerified
      isParentVerified
      isSelfEmailVerified
      isparentRequestSent
      mobileSmsTriggerCnt
      selfEmailTriggerCnt
      parentRequestSentTriggerCnt
      welcomeEmailSentCnt
      mobileSmsTriggerDt
      selfEmailTriggerDt
      parentRequestSentTriggerDt
      welcomeEmailSentDt
      mobileReminderSmsTriggerCnt
      mobileReminderSmsTriggerDt
      mobileCountrycode
      parentmobileCountrycode
      isTestUser
      source
      isAdmin
      adminSchoolName
      adminCompanyName
      adminIssuingOrganisation
      adminAccomplishmentsProvider
      adminMembershipOrganisation
      adminLogo
      state
      tblrolemappingID
      userProfileDetailsUserMasterId
      userType
      username
      UserCards {
        items {
          id
          restricted
          status
          title
          type
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCardsId
          __typename
        }
        nextToken
        __typename
      }
      UserCvs {
        items {
          cv_title
          description
          id
          link
          password
          restricted
          status
          userprofiledetailsID
          createdAt
          updatedAt
          userProfileDetailsUserCvsId
          __typename
        }
        nextToken
        __typename
      }
      connections {
        items {
          id
          userProfileDetailsId
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      notifications {
        items {
          id
          action
          content
          delete
          read
          subject
          turnoffsimilar
          createdAt
          updatedAt
          userProfileDetailsNotificationsId
          __typename
        }
        nextToken
        __typename
      }
      userActivity {
        items {
          id
          cartItem_id
          status
          type
          data
          createdAt
          updatedAt
          userProfileDetailsUserActivityId
          __typename
        }
        nextToken
        __typename
      }
      posts {
        items {
          id
          rootPostId
          refrencePostId
          cardItemID
          postType
          createdAt
          updatedAt
          userProfileDetailsPostsId
          __typename
        }
        nextToken
        __typename
      }
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentsId
          postsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      CommentOne {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentOneId
          commentsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      likes {
        items {
          id
          status
          createdAt
          updatedAt
          userProfileDetailsLikesId
          postsLikesId
          __typename
        }
        nextToken
        __typename
      }
      views {
        items {
          id
          ipAddress
          status
          createdAt
          updatedAt
          userProfileDetailsViewsId
          postsViewsId
          __typename
        }
        nextToken
        __typename
      }
      quizResults {
        items {
          id
          iSpringID
          quizCategory
          quizLevel
          quizTitle
          quizGrade
          quizSeqNo
          totalScore
          quizScore
          status
          createdAt
          updatedAt
          userProfileDetailsQuizResultsId
          postsQuizResultsId
          __typename
        }
        nextToken
        __typename
      }
      registeredDate
      adminSchoolType
      quizAvgScore
      interests {
        items {
          id
          userInterestID
          interestID
          createdAt
          updatedAt
          userProfileDetailsInterestsId
          interestUsersId
          __typename
        }
        nextToken
        __typename
      }
      subinterests {
        items {
          id
          userInterestID
          subinterestID
          createdAt
          updatedAt
          userProfileDetailsSubinterestsId
          subinterestUsersId
          __typename
        }
        nextToken
        __typename
      }
      quizStudent {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          userProfileDetailsQuizStudentId
          quizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      moduleStudentQuestionResult {
        items {
          id
          iSpringID
          moduleCategory
          moduleLevel
          moduleTitle
          moduleGrade
          moduleSeqNo
          questionIndex
          questionText
          totalScore
          schoolName
          schoolLocation
          userAnswer
          creatorEmail
          Status
          correctAnswer
          pointsAllotted
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsModuleStudentQuestionResultId
          postsStudentModuleQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      connectedInstituteAdmins
      connectionsCount
      portfolioCount
      blogCount
      diaryCount
      cvCount
      mystuffCount
      createdAt
      updatedAt
      userMasterUserProfileDetailsId
      __typename
    }
  }
`;
export const createCard = /* GraphQL */ `
  mutation CreateCard(
    $input: CreateCardInput!
    $condition: ModelCardConditionInput
  ) {
    createCard(input: $input, condition: $condition) {
      id
      restricted
      status
      title
      type
      userprofiledetailsID
      userCardID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      UserCardItemss {
        items {
          cardID
          data
          newdata
          id
          restricted
          status
          schoolName
          currentStuding
          companyName
          currentlyWorking
          issuingOrganisation
          accomplishmentsProvider
          membershipOrganisation
          courseName
          branchName
          batchName
          referralCode
          location
          createdAt
          updatedAt
          cardUserCardItemssId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsUserCardsId
      __typename
    }
  }
`;
export const updateCard = /* GraphQL */ `
  mutation UpdateCard(
    $input: UpdateCardInput!
    $condition: ModelCardConditionInput
  ) {
    updateCard(input: $input, condition: $condition) {
      id
      restricted
      status
      title
      type
      userprofiledetailsID
      userCardID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      UserCardItemss {
        items {
          cardID
          data
          newdata
          id
          restricted
          status
          schoolName
          currentStuding
          companyName
          currentlyWorking
          issuingOrganisation
          accomplishmentsProvider
          membershipOrganisation
          courseName
          branchName
          batchName
          referralCode
          location
          createdAt
          updatedAt
          cardUserCardItemssId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsUserCardsId
      __typename
    }
  }
`;
export const deleteCard = /* GraphQL */ `
  mutation DeleteCard(
    $input: DeleteCardInput!
    $condition: ModelCardConditionInput
  ) {
    deleteCard(input: $input, condition: $condition) {
      id
      restricted
      status
      title
      type
      userprofiledetailsID
      userCardID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      UserCardItemss {
        items {
          cardID
          data
          newdata
          id
          restricted
          status
          schoolName
          currentStuding
          companyName
          currentlyWorking
          issuingOrganisation
          accomplishmentsProvider
          membershipOrganisation
          courseName
          branchName
          batchName
          referralCode
          location
          createdAt
          updatedAt
          cardUserCardItemssId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsUserCardsId
      __typename
    }
  }
`;
export const createCardItems = /* GraphQL */ `
  mutation CreateCardItems(
    $input: CreateCardItemsInput!
    $condition: ModelCardItemsConditionInput
  ) {
    createCardItems(input: $input, condition: $condition) {
      cardID
      data
      newdata
      id
      restricted
      status
      schoolName
      currentStuding
      companyName
      currentlyWorking
      issuingOrganisation
      accomplishmentsProvider
      membershipOrganisation
      courseName
      branchName
      batchName
      referralCode
      location
      userCardItemsID {
        id
        restricted
        status
        title
        type
        userprofiledetailsID
        userCardID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        UserCardItemss {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsUserCardsId
        __typename
      }
      createdAt
      updatedAt
      cardUserCardItemssId
      __typename
    }
  }
`;
export const updateCardItems = /* GraphQL */ `
  mutation UpdateCardItems(
    $input: UpdateCardItemsInput!
    $condition: ModelCardItemsConditionInput
  ) {
    updateCardItems(input: $input, condition: $condition) {
      cardID
      data
      newdata
      id
      restricted
      status
      schoolName
      currentStuding
      companyName
      currentlyWorking
      issuingOrganisation
      accomplishmentsProvider
      membershipOrganisation
      courseName
      branchName
      batchName
      referralCode
      location
      userCardItemsID {
        id
        restricted
        status
        title
        type
        userprofiledetailsID
        userCardID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        UserCardItemss {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsUserCardsId
        __typename
      }
      createdAt
      updatedAt
      cardUserCardItemssId
      __typename
    }
  }
`;
export const deleteCardItems = /* GraphQL */ `
  mutation DeleteCardItems(
    $input: DeleteCardItemsInput!
    $condition: ModelCardItemsConditionInput
  ) {
    deleteCardItems(input: $input, condition: $condition) {
      cardID
      data
      newdata
      id
      restricted
      status
      schoolName
      currentStuding
      companyName
      currentlyWorking
      issuingOrganisation
      accomplishmentsProvider
      membershipOrganisation
      courseName
      branchName
      batchName
      referralCode
      location
      userCardItemsID {
        id
        restricted
        status
        title
        type
        userprofiledetailsID
        userCardID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        UserCardItemss {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsUserCardsId
        __typename
      }
      createdAt
      updatedAt
      cardUserCardItemssId
      __typename
    }
  }
`;
export const createEventMaster = /* GraphQL */ `
  mutation CreateEventMaster(
    $input: CreateEventMasterInput!
    $condition: ModelEventMasterConditionInput
  ) {
    createEventMaster(input: $input, condition: $condition) {
      event_module
      event_name
      event_sub_module
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEventMaster = /* GraphQL */ `
  mutation UpdateEventMaster(
    $input: UpdateEventMasterInput!
    $condition: ModelEventMasterConditionInput
  ) {
    updateEventMaster(input: $input, condition: $condition) {
      event_module
      event_name
      event_sub_module
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEventMaster = /* GraphQL */ `
  mutation DeleteEventMaster(
    $input: DeleteEventMasterInput!
    $condition: ModelEventMasterConditionInput
  ) {
    deleteEventMaster(input: $input, condition: $condition) {
      event_module
      event_name
      event_sub_module
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEventTransactions = /* GraphQL */ `
  mutation CreateEventTransactions(
    $input: CreateEventTransactionsInput!
    $condition: ModelEventTransactionsConditionInput
  ) {
    createEventTransactions(input: $input, condition: $condition) {
      action_done_by_user_id
      createdAt
      entity_id
      entity_owner_user_id
      id
      payload_after
      payload_before
      userBrowser
      userOS
      userDevice
      userIP
      userReferrer
      registrationType
      interests
      status
      updatedAt
      __typename
    }
  }
`;
export const updateEventTransactions = /* GraphQL */ `
  mutation UpdateEventTransactions(
    $input: UpdateEventTransactionsInput!
    $condition: ModelEventTransactionsConditionInput
  ) {
    updateEventTransactions(input: $input, condition: $condition) {
      action_done_by_user_id
      createdAt
      entity_id
      entity_owner_user_id
      id
      payload_after
      payload_before
      userBrowser
      userOS
      userDevice
      userIP
      userReferrer
      registrationType
      interests
      status
      updatedAt
      __typename
    }
  }
`;
export const deleteEventTransactions = /* GraphQL */ `
  mutation DeleteEventTransactions(
    $input: DeleteEventTransactionsInput!
    $condition: ModelEventTransactionsConditionInput
  ) {
    deleteEventTransactions(input: $input, condition: $condition) {
      action_done_by_user_id
      createdAt
      entity_id
      entity_owner_user_id
      id
      payload_after
      payload_before
      userBrowser
      userOS
      userDevice
      userIP
      userReferrer
      registrationType
      interests
      status
      updatedAt
      __typename
    }
  }
`;
export const createServicesLogs = /* GraphQL */ `
  mutation CreateServicesLogs(
    $input: CreateServicesLogsInput!
    $condition: ModelServicesLogsConditionInput
  ) {
    createServicesLogs(input: $input, condition: $condition) {
      createdAt
      id
      module
      request
      response
      status
      type
      updatedAt
      __typename
    }
  }
`;
export const updateServicesLogs = /* GraphQL */ `
  mutation UpdateServicesLogs(
    $input: UpdateServicesLogsInput!
    $condition: ModelServicesLogsConditionInput
  ) {
    updateServicesLogs(input: $input, condition: $condition) {
      createdAt
      id
      module
      request
      response
      status
      type
      updatedAt
      __typename
    }
  }
`;
export const deleteServicesLogs = /* GraphQL */ `
  mutation DeleteServicesLogs(
    $input: DeleteServicesLogsInput!
    $condition: ModelServicesLogsConditionInput
  ) {
    deleteServicesLogs(input: $input, condition: $condition) {
      createdAt
      id
      module
      request
      response
      status
      type
      updatedAt
      __typename
    }
  }
`;
export const createSettings = /* GraphQL */ `
  mutation CreateSettings(
    $input: CreateSettingsInput!
    $condition: ModelSettingsConditionInput
  ) {
    createSettings(input: $input, condition: $condition) {
      id
      module
      setting
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSettings = /* GraphQL */ `
  mutation UpdateSettings(
    $input: UpdateSettingsInput!
    $condition: ModelSettingsConditionInput
  ) {
    updateSettings(input: $input, condition: $condition) {
      id
      module
      setting
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSettings = /* GraphQL */ `
  mutation DeleteSettings(
    $input: DeleteSettingsInput!
    $condition: ModelSettingsConditionInput
  ) {
    deleteSettings(input: $input, condition: $condition) {
      id
      module
      setting
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblBadgeDetails = /* GraphQL */ `
  mutation CreateTblBadgeDetails(
    $input: CreateTblBadgeDetailsInput!
    $condition: ModelTblBadgeDetailsConditionInput
  ) {
    createTblBadgeDetails(input: $input, condition: $condition) {
      id
      issue_date
      restricted
      school_name
      status
      tblbadgemasterID
      userprofiledetailsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblBadgeDetails = /* GraphQL */ `
  mutation UpdateTblBadgeDetails(
    $input: UpdateTblBadgeDetailsInput!
    $condition: ModelTblBadgeDetailsConditionInput
  ) {
    updateTblBadgeDetails(input: $input, condition: $condition) {
      id
      issue_date
      restricted
      school_name
      status
      tblbadgemasterID
      userprofiledetailsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblBadgeDetails = /* GraphQL */ `
  mutation DeleteTblBadgeDetails(
    $input: DeleteTblBadgeDetailsInput!
    $condition: ModelTblBadgeDetailsConditionInput
  ) {
    deleteTblBadgeDetails(input: $input, condition: $condition) {
      id
      issue_date
      restricted
      school_name
      status
      tblbadgemasterID
      userprofiledetailsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblBadgeMaster = /* GraphQL */ `
  mutation CreateTblBadgeMaster(
    $input: CreateTblBadgeMasterInput!
    $condition: ModelTblBadgeMasterConditionInput
  ) {
    createTblBadgeMaster(input: $input, condition: $condition) {
      badge_image
      badge_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblBadgeMaster = /* GraphQL */ `
  mutation UpdateTblBadgeMaster(
    $input: UpdateTblBadgeMasterInput!
    $condition: ModelTblBadgeMasterConditionInput
  ) {
    updateTblBadgeMaster(input: $input, condition: $condition) {
      badge_image
      badge_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblBadgeMaster = /* GraphQL */ `
  mutation DeleteTblBadgeMaster(
    $input: DeleteTblBadgeMasterInput!
    $condition: ModelTblBadgeMasterConditionInput
  ) {
    deleteTblBadgeMaster(input: $input, condition: $condition) {
      badge_image
      badge_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblCVDetails = /* GraphQL */ `
  mutation CreateTblCVDetails(
    $input: CreateTblCVDetailsInput!
    $condition: ModelTblCVDetailsConditionInput
  ) {
    createTblCVDetails(input: $input, condition: $condition) {
      cv_title
      description
      id
      link
      password
      restricted
      status
      userprofiledetailsID
      usercvID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsUserCvsId
      __typename
    }
  }
`;
export const updateTblCVDetails = /* GraphQL */ `
  mutation UpdateTblCVDetails(
    $input: UpdateTblCVDetailsInput!
    $condition: ModelTblCVDetailsConditionInput
  ) {
    updateTblCVDetails(input: $input, condition: $condition) {
      cv_title
      description
      id
      link
      password
      restricted
      status
      userprofiledetailsID
      usercvID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsUserCvsId
      __typename
    }
  }
`;
export const deleteTblCVDetails = /* GraphQL */ `
  mutation DeleteTblCVDetails(
    $input: DeleteTblCVDetailsInput!
    $condition: ModelTblCVDetailsConditionInput
  ) {
    deleteTblCVDetails(input: $input, condition: $condition) {
      cv_title
      description
      id
      link
      password
      restricted
      status
      userprofiledetailsID
      usercvID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsUserCvsId
      __typename
    }
  }
`;
export const createTblCourse = /* GraphQL */ `
  mutation CreateTblCourse(
    $input: CreateTblCourseInput!
    $condition: ModelTblCourseConditionInput
  ) {
    createTblCourse(input: $input, condition: $condition) {
      course_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblCourse = /* GraphQL */ `
  mutation UpdateTblCourse(
    $input: UpdateTblCourseInput!
    $condition: ModelTblCourseConditionInput
  ) {
    updateTblCourse(input: $input, condition: $condition) {
      course_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblCourse = /* GraphQL */ `
  mutation DeleteTblCourse(
    $input: DeleteTblCourseInput!
    $condition: ModelTblCourseConditionInput
  ) {
    deleteTblCourse(input: $input, condition: $condition) {
      course_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblEmployees = /* GraphQL */ `
  mutation CreateTblEmployees(
    $input: CreateTblEmployeesInput!
    $condition: ModelTblEmployeesConditionInput
  ) {
    createTblEmployees(input: $input, condition: $condition) {
      employment_type
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblEmployees = /* GraphQL */ `
  mutation UpdateTblEmployees(
    $input: UpdateTblEmployeesInput!
    $condition: ModelTblEmployeesConditionInput
  ) {
    updateTblEmployees(input: $input, condition: $condition) {
      employment_type
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblEmployees = /* GraphQL */ `
  mutation DeleteTblEmployees(
    $input: DeleteTblEmployeesInput!
    $condition: ModelTblEmployeesConditionInput
  ) {
    deleteTblEmployees(input: $input, condition: $condition) {
      employment_type
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblGradeMaster = /* GraphQL */ `
  mutation CreateTblGradeMaster(
    $input: CreateTblGradeMasterInput!
    $condition: ModelTblGradeMasterConditionInput
  ) {
    createTblGradeMaster(input: $input, condition: $condition) {
      grade_name
      id
      series
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblGradeMaster = /* GraphQL */ `
  mutation UpdateTblGradeMaster(
    $input: UpdateTblGradeMasterInput!
    $condition: ModelTblGradeMasterConditionInput
  ) {
    updateTblGradeMaster(input: $input, condition: $condition) {
      grade_name
      id
      series
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblGradeMaster = /* GraphQL */ `
  mutation DeleteTblGradeMaster(
    $input: DeleteTblGradeMasterInput!
    $condition: ModelTblGradeMasterConditionInput
  ) {
    deleteTblGradeMaster(input: $input, condition: $condition) {
      grade_name
      id
      series
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblHobbiesMaster = /* GraphQL */ `
  mutation CreateTblHobbiesMaster(
    $input: CreateTblHobbiesMasterInput!
    $condition: ModelTblHobbiesMasterConditionInput
  ) {
    createTblHobbiesMaster(input: $input, condition: $condition) {
      hobbies_image
      hobbies_name
      id
      status
      userprofiledetailsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblHobbiesMaster = /* GraphQL */ `
  mutation UpdateTblHobbiesMaster(
    $input: UpdateTblHobbiesMasterInput!
    $condition: ModelTblHobbiesMasterConditionInput
  ) {
    updateTblHobbiesMaster(input: $input, condition: $condition) {
      hobbies_image
      hobbies_name
      id
      status
      userprofiledetailsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblHobbiesMaster = /* GraphQL */ `
  mutation DeleteTblHobbiesMaster(
    $input: DeleteTblHobbiesMasterInput!
    $condition: ModelTblHobbiesMasterConditionInput
  ) {
    deleteTblHobbiesMaster(input: $input, condition: $condition) {
      hobbies_image
      hobbies_name
      id
      status
      userprofiledetailsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblIndustry = /* GraphQL */ `
  mutation CreateTblIndustry(
    $input: CreateTblIndustryInput!
    $condition: ModelTblIndustryConditionInput
  ) {
    createTblIndustry(input: $input, condition: $condition) {
      id
      industry_name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblIndustry = /* GraphQL */ `
  mutation UpdateTblIndustry(
    $input: UpdateTblIndustryInput!
    $condition: ModelTblIndustryConditionInput
  ) {
    updateTblIndustry(input: $input, condition: $condition) {
      id
      industry_name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblIndustry = /* GraphQL */ `
  mutation DeleteTblIndustry(
    $input: DeleteTblIndustryInput!
    $condition: ModelTblIndustryConditionInput
  ) {
    deleteTblIndustry(input: $input, condition: $condition) {
      id
      industry_name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblLang = /* GraphQL */ `
  mutation CreateTblLang(
    $input: CreateTblLangInput!
    $condition: ModelTblLangConditionInput
  ) {
    createTblLang(input: $input, condition: $condition) {
      Language_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblLang = /* GraphQL */ `
  mutation UpdateTblLang(
    $input: UpdateTblLangInput!
    $condition: ModelTblLangConditionInput
  ) {
    updateTblLang(input: $input, condition: $condition) {
      Language_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblLang = /* GraphQL */ `
  mutation DeleteTblLang(
    $input: DeleteTblLangInput!
    $condition: ModelTblLangConditionInput
  ) {
    deleteTblLang(input: $input, condition: $condition) {
      Language_name
      id
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblOtpEmail = /* GraphQL */ `
  mutation CreateTblOtpEmail(
    $input: CreateTblOtpEmailInput!
    $condition: ModelTblOtpEmailConditionInput
  ) {
    createTblOtpEmail(input: $input, condition: $condition) {
      email
      id
      otp
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblOtpEmail = /* GraphQL */ `
  mutation UpdateTblOtpEmail(
    $input: UpdateTblOtpEmailInput!
    $condition: ModelTblOtpEmailConditionInput
  ) {
    updateTblOtpEmail(input: $input, condition: $condition) {
      email
      id
      otp
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblOtpEmail = /* GraphQL */ `
  mutation DeleteTblOtpEmail(
    $input: DeleteTblOtpEmailInput!
    $condition: ModelTblOtpEmailConditionInput
  ) {
    deleteTblOtpEmail(input: $input, condition: $condition) {
      email
      id
      otp
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblOtpMobile = /* GraphQL */ `
  mutation CreateTblOtpMobile(
    $input: CreateTblOtpMobileInput!
    $condition: ModelTblOtpMobileConditionInput
  ) {
    createTblOtpMobile(input: $input, condition: $condition) {
      id
      mobile_no
      otp
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblOtpMobile = /* GraphQL */ `
  mutation UpdateTblOtpMobile(
    $input: UpdateTblOtpMobileInput!
    $condition: ModelTblOtpMobileConditionInput
  ) {
    updateTblOtpMobile(input: $input, condition: $condition) {
      id
      mobile_no
      otp
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblOtpMobile = /* GraphQL */ `
  mutation DeleteTblOtpMobile(
    $input: DeleteTblOtpMobileInput!
    $condition: ModelTblOtpMobileConditionInput
  ) {
    deleteTblOtpMobile(input: $input, condition: $condition) {
      id
      mobile_no
      otp
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblPortfolioProjectSubjects = /* GraphQL */ `
  mutation CreateTblPortfolioProjectSubjects(
    $input: CreateTblPortfolioProjectSubjectsInput!
    $condition: ModelTblPortfolioProjectSubjectsConditionInput
  ) {
    createTblPortfolioProjectSubjects(input: $input, condition: $condition) {
      id
      status
      subject_name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblPortfolioProjectSubjects = /* GraphQL */ `
  mutation UpdateTblPortfolioProjectSubjects(
    $input: UpdateTblPortfolioProjectSubjectsInput!
    $condition: ModelTblPortfolioProjectSubjectsConditionInput
  ) {
    updateTblPortfolioProjectSubjects(input: $input, condition: $condition) {
      id
      status
      subject_name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblPortfolioProjectSubjects = /* GraphQL */ `
  mutation DeleteTblPortfolioProjectSubjects(
    $input: DeleteTblPortfolioProjectSubjectsInput!
    $condition: ModelTblPortfolioProjectSubjectsConditionInput
  ) {
    deleteTblPortfolioProjectSubjects(input: $input, condition: $condition) {
      id
      status
      subject_name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTblSkillsMaster = /* GraphQL */ `
  mutation CreateTblSkillsMaster(
    $input: CreateTblSkillsMasterInput!
    $condition: ModelTblSkillsMasterConditionInput
  ) {
    createTblSkillsMaster(input: $input, condition: $condition) {
      id
      skill_name
      skill_type
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTblSkillsMaster = /* GraphQL */ `
  mutation UpdateTblSkillsMaster(
    $input: UpdateTblSkillsMasterInput!
    $condition: ModelTblSkillsMasterConditionInput
  ) {
    updateTblSkillsMaster(input: $input, condition: $condition) {
      id
      skill_name
      skill_type
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTblSkillsMaster = /* GraphQL */ `
  mutation DeleteTblSkillsMaster(
    $input: DeleteTblSkillsMasterInput!
    $condition: ModelTblSkillsMasterConditionInput
  ) {
    deleteTblSkillsMaster(input: $input, condition: $condition) {
      id
      skill_name
      skill_type
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMyIndTable = /* GraphQL */ `
  mutation CreateMyIndTable(
    $input: CreateMyIndTableInput!
    $condition: ModelMyIndTableConditionInput
  ) {
    createMyIndTable(input: $input, condition: $condition) {
      content
      id
      price
      rating
      title
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMyIndTable = /* GraphQL */ `
  mutation UpdateMyIndTable(
    $input: UpdateMyIndTableInput!
    $condition: ModelMyIndTableConditionInput
  ) {
    updateMyIndTable(input: $input, condition: $condition) {
      content
      id
      price
      rating
      title
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMyIndTable = /* GraphQL */ `
  mutation DeleteMyIndTable(
    $input: DeleteMyIndTableInput!
    $condition: ModelMyIndTableConditionInput
  ) {
    deleteMyIndTable(input: $input, condition: $condition) {
      content
      id
      price
      rating
      title
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTmpUserDetails = /* GraphQL */ `
  mutation CreateTmpUserDetails(
    $input: CreateTmpUserDetailsInput!
    $condition: ModelTmpUserDetailsConditionInput
  ) {
    createTmpUserDetails(input: $input, condition: $condition) {
      city
      country
      dob
      email
      first_name
      gender
      id
      job
      last_name
      middle_name
      mobile_no
      parent_email
      parent_mobile
      parent_name
      referralCode
      state
      status
      userType
      username
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTmpUserDetails = /* GraphQL */ `
  mutation UpdateTmpUserDetails(
    $input: UpdateTmpUserDetailsInput!
    $condition: ModelTmpUserDetailsConditionInput
  ) {
    updateTmpUserDetails(input: $input, condition: $condition) {
      city
      country
      dob
      email
      first_name
      gender
      id
      job
      last_name
      middle_name
      mobile_no
      parent_email
      parent_mobile
      parent_name
      referralCode
      state
      status
      userType
      username
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTmpUserDetails = /* GraphQL */ `
  mutation DeleteTmpUserDetails(
    $input: DeleteTmpUserDetailsInput!
    $condition: ModelTmpUserDetailsConditionInput
  ) {
    deleteTmpUserDetails(input: $input, condition: $condition) {
      city
      country
      dob
      email
      first_name
      gender
      id
      job
      last_name
      middle_name
      mobile_no
      parent_email
      parent_mobile
      parent_name
      referralCode
      state
      status
      userType
      username
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createConnection = /* GraphQL */ `
  mutation CreateConnection(
    $input: CreateConnectionInput!
    $condition: ModelConnectionConditionInput
  ) {
    createConnection(input: $input, condition: $condition) {
      id
      tag
      users {
        items {
          id
          userProfileDetailsId
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tags {
        id
        tag_name
        type
        tagConnect {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      tagMasterTagConnectId
      __typename
    }
  }
`;
export const updateConnection = /* GraphQL */ `
  mutation UpdateConnection(
    $input: UpdateConnectionInput!
    $condition: ModelConnectionConditionInput
  ) {
    updateConnection(input: $input, condition: $condition) {
      id
      tag
      users {
        items {
          id
          userProfileDetailsId
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tags {
        id
        tag_name
        type
        tagConnect {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      tagMasterTagConnectId
      __typename
    }
  }
`;
export const deleteConnection = /* GraphQL */ `
  mutation DeleteConnection(
    $input: DeleteConnectionInput!
    $condition: ModelConnectionConditionInput
  ) {
    deleteConnection(input: $input, condition: $condition) {
      id
      tag
      users {
        items {
          id
          userProfileDetailsId
          connectionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      tags {
        id
        tag_name
        type
        tagConnect {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      tagMasterTagConnectId
      __typename
    }
  }
`;
export const createFriendRequest = /* GraphQL */ `
  mutation CreateFriendRequest(
    $input: CreateFriendRequestInput!
    $condition: ModelFriendRequestConditionInput
  ) {
    createFriendRequest(input: $input, condition: $condition) {
      id
      from_user_id
      to_user_id
      status
      accept_date
      decline_date
      connectionFriendID
      isAdminTriggered
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFriendRequest = /* GraphQL */ `
  mutation UpdateFriendRequest(
    $input: UpdateFriendRequestInput!
    $condition: ModelFriendRequestConditionInput
  ) {
    updateFriendRequest(input: $input, condition: $condition) {
      id
      from_user_id
      to_user_id
      status
      accept_date
      decline_date
      connectionFriendID
      isAdminTriggered
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFriendRequest = /* GraphQL */ `
  mutation DeleteFriendRequest(
    $input: DeleteFriendRequestInput!
    $condition: ModelFriendRequestConditionInput
  ) {
    deleteFriendRequest(input: $input, condition: $condition) {
      id
      from_user_id
      to_user_id
      status
      accept_date
      decline_date
      connectionFriendID
      isAdminTriggered
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTagMaster = /* GraphQL */ `
  mutation CreateTagMaster(
    $input: CreateTagMasterInput!
    $condition: ModelTagMasterConditionInput
  ) {
    createTagMaster(input: $input, condition: $condition) {
      id
      tag_name
      type
      tagConnect {
        items {
          id
          tag
          createdAt
          updatedAt
          tagMasterTagConnectId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTagMaster = /* GraphQL */ `
  mutation UpdateTagMaster(
    $input: UpdateTagMasterInput!
    $condition: ModelTagMasterConditionInput
  ) {
    updateTagMaster(input: $input, condition: $condition) {
      id
      tag_name
      type
      tagConnect {
        items {
          id
          tag
          createdAt
          updatedAt
          tagMasterTagConnectId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTagMaster = /* GraphQL */ `
  mutation DeleteTagMaster(
    $input: DeleteTagMasterInput!
    $condition: ModelTagMasterConditionInput
  ) {
    deleteTagMaster(input: $input, condition: $condition) {
      id
      tag_name
      type
      tagConnect {
        items {
          id
          tag
          createdAt
          updatedAt
          tagMasterTagConnectId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCountries = /* GraphQL */ `
  mutation CreateCountries(
    $input: CreateCountriesInput!
    $condition: ModelCountriesConditionInput
  ) {
    createCountries(input: $input, condition: $condition) {
      id
      name
      iso3
      iso2
      numeric_code
      phone_code
      capital
      currency
      currency_name
      currency_symbol
      native
      region
      subregion
      latitude
      longitude
      emoji
      emojiU
      states {
        items {
          id
          name
          state_code
          latitude
          longitude
          createdAt
          updatedAt
          countriesStatesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCountries = /* GraphQL */ `
  mutation UpdateCountries(
    $input: UpdateCountriesInput!
    $condition: ModelCountriesConditionInput
  ) {
    updateCountries(input: $input, condition: $condition) {
      id
      name
      iso3
      iso2
      numeric_code
      phone_code
      capital
      currency
      currency_name
      currency_symbol
      native
      region
      subregion
      latitude
      longitude
      emoji
      emojiU
      states {
        items {
          id
          name
          state_code
          latitude
          longitude
          createdAt
          updatedAt
          countriesStatesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCountries = /* GraphQL */ `
  mutation DeleteCountries(
    $input: DeleteCountriesInput!
    $condition: ModelCountriesConditionInput
  ) {
    deleteCountries(input: $input, condition: $condition) {
      id
      name
      iso3
      iso2
      numeric_code
      phone_code
      capital
      currency
      currency_name
      currency_symbol
      native
      region
      subregion
      latitude
      longitude
      emoji
      emojiU
      states {
        items {
          id
          name
          state_code
          latitude
          longitude
          createdAt
          updatedAt
          countriesStatesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStates = /* GraphQL */ `
  mutation CreateStates(
    $input: CreateStatesInput!
    $condition: ModelStatesConditionInput
  ) {
    createStates(input: $input, condition: $condition) {
      id
      name
      state_code
      latitude
      longitude
      cities {
        items {
          id
          name
          latitude
          longitude
          createdAt
          updatedAt
          statesCitiesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      countriesStatesId
      __typename
    }
  }
`;
export const updateStates = /* GraphQL */ `
  mutation UpdateStates(
    $input: UpdateStatesInput!
    $condition: ModelStatesConditionInput
  ) {
    updateStates(input: $input, condition: $condition) {
      id
      name
      state_code
      latitude
      longitude
      cities {
        items {
          id
          name
          latitude
          longitude
          createdAt
          updatedAt
          statesCitiesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      countriesStatesId
      __typename
    }
  }
`;
export const deleteStates = /* GraphQL */ `
  mutation DeleteStates(
    $input: DeleteStatesInput!
    $condition: ModelStatesConditionInput
  ) {
    deleteStates(input: $input, condition: $condition) {
      id
      name
      state_code
      latitude
      longitude
      cities {
        items {
          id
          name
          latitude
          longitude
          createdAt
          updatedAt
          statesCitiesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      countriesStatesId
      __typename
    }
  }
`;
export const createCities = /* GraphQL */ `
  mutation CreateCities(
    $input: CreateCitiesInput!
    $condition: ModelCitiesConditionInput
  ) {
    createCities(input: $input, condition: $condition) {
      id
      name
      latitude
      longitude
      createdAt
      updatedAt
      statesCitiesId
      __typename
    }
  }
`;
export const updateCities = /* GraphQL */ `
  mutation UpdateCities(
    $input: UpdateCitiesInput!
    $condition: ModelCitiesConditionInput
  ) {
    updateCities(input: $input, condition: $condition) {
      id
      name
      latitude
      longitude
      createdAt
      updatedAt
      statesCitiesId
      __typename
    }
  }
`;
export const deleteCities = /* GraphQL */ `
  mutation DeleteCities(
    $input: DeleteCitiesInput!
    $condition: ModelCitiesConditionInput
  ) {
    deleteCities(input: $input, condition: $condition) {
      id
      name
      latitude
      longitude
      createdAt
      updatedAt
      statesCitiesId
      __typename
    }
  }
`;
export const createSpamReports = /* GraphQL */ `
  mutation CreateSpamReports(
    $input: CreateSpamReportsInput!
    $condition: ModelSpamReportsConditionInput
  ) {
    createSpamReports(input: $input, condition: $condition) {
      id
      reportTo
      reportToName
      reportToEmail
      reportFrom
      reportFromName
      reportFromEmail
      reportedItemType
      reportedPost
      isActionTaken
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSpamReports = /* GraphQL */ `
  mutation UpdateSpamReports(
    $input: UpdateSpamReportsInput!
    $condition: ModelSpamReportsConditionInput
  ) {
    updateSpamReports(input: $input, condition: $condition) {
      id
      reportTo
      reportToName
      reportToEmail
      reportFrom
      reportFromName
      reportFromEmail
      reportedItemType
      reportedPost
      isActionTaken
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSpamReports = /* GraphQL */ `
  mutation DeleteSpamReports(
    $input: DeleteSpamReportsInput!
    $condition: ModelSpamReportsConditionInput
  ) {
    deleteSpamReports(input: $input, condition: $condition) {
      id
      reportTo
      reportToName
      reportToEmail
      reportFrom
      reportFromName
      reportFromEmail
      reportedItemType
      reportedPost
      isActionTaken
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInviteConnections = /* GraphQL */ `
  mutation CreateInviteConnections(
    $input: CreateInviteConnectionsInput!
    $condition: ModelInviteConnectionsConditionInput
  ) {
    createInviteConnections(input: $input, condition: $condition) {
      id
      senderUserId
      senderUserEmail
      senderUserName
      toEmail
      toName
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInviteConnections = /* GraphQL */ `
  mutation UpdateInviteConnections(
    $input: UpdateInviteConnectionsInput!
    $condition: ModelInviteConnectionsConditionInput
  ) {
    updateInviteConnections(input: $input, condition: $condition) {
      id
      senderUserId
      senderUserEmail
      senderUserName
      toEmail
      toName
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInviteConnections = /* GraphQL */ `
  mutation DeleteInviteConnections(
    $input: DeleteInviteConnectionsInput!
    $condition: ModelInviteConnectionsConditionInput
  ) {
    deleteInviteConnections(input: $input, condition: $condition) {
      id
      senderUserId
      senderUserEmail
      senderUserName
      toEmail
      toName
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNotifications = /* GraphQL */ `
  mutation CreateNotifications(
    $input: CreateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    createNotifications(input: $input, condition: $condition) {
      id
      action
      content
      delete
      read
      subject
      turnoffsimilar
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsNotificationsId
      __typename
    }
  }
`;
export const updateNotifications = /* GraphQL */ `
  mutation UpdateNotifications(
    $input: UpdateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    updateNotifications(input: $input, condition: $condition) {
      id
      action
      content
      delete
      read
      subject
      turnoffsimilar
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsNotificationsId
      __typename
    }
  }
`;
export const deleteNotifications = /* GraphQL */ `
  mutation DeleteNotifications(
    $input: DeleteNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    deleteNotifications(input: $input, condition: $condition) {
      id
      action
      content
      delete
      read
      subject
      turnoffsimilar
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsNotificationsId
      __typename
    }
  }
`;
export const createNotificationsRules = /* GraphQL */ `
  mutation CreateNotificationsRules(
    $input: CreateNotificationsRulesInput!
    $condition: ModelNotificationsRulesConditionInput
  ) {
    createNotificationsRules(input: $input, condition: $condition) {
      id
      category
      subcategory
      subject
      templates
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNotificationsRules = /* GraphQL */ `
  mutation UpdateNotificationsRules(
    $input: UpdateNotificationsRulesInput!
    $condition: ModelNotificationsRulesConditionInput
  ) {
    updateNotificationsRules(input: $input, condition: $condition) {
      id
      category
      subcategory
      subject
      templates
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNotificationsRules = /* GraphQL */ `
  mutation DeleteNotificationsRules(
    $input: DeleteNotificationsRulesInput!
    $condition: ModelNotificationsRulesConditionInput
  ) {
    deleteNotificationsRules(input: $input, condition: $condition) {
      id
      category
      subcategory
      subject
      templates
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserActivity = /* GraphQL */ `
  mutation CreateUserActivity(
    $input: CreateUserActivityInput!
    $condition: ModelUserActivityConditionInput
  ) {
    createUserActivity(input: $input, condition: $condition) {
      id
      from_user_id {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      to_user_id {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        connectionsCount
        portfolioCount
        blogCount
        diaryCount
        cvCount
        mystuffCount
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      cartItem_id
      status
      type
      data
      createdAt
      updatedAt
      userProfileDetailsUserActivityId
      __typename
    }
  }
`;
export const updateUserActivity = /* GraphQL */ `
  mutation UpdateUserActivity(
    $input: UpdateUserActivityInput!
    $condition: ModelUserActivityConditionInput
  ) {
    updateUserActivity(input: $input, condition: $condition) {
      id
      from_user_id {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      to_user_id {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      cartItem_id
      status
      type
      data
      createdAt
      updatedAt
      userProfileDetailsUserActivityId
      __typename
    }
  }
`;
export const deleteUserActivity = /* GraphQL */ `
  mutation DeleteUserActivity(
    $input: DeleteUserActivityInput!
    $condition: ModelUserActivityConditionInput
  ) {
    deleteUserActivity(input: $input, condition: $condition) {
      id
      from_user_id {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      to_user_id {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      cartItem_id
      status
      type
      data
      createdAt
      updatedAt
      userProfileDetailsUserActivityId
      __typename
    }
  }
`;
export const createPosts = /* GraphQL */ `
  mutation CreatePosts(
    $input: CreatePostsInput!
    $condition: ModelPostsConditionInput
  ) {
    createPosts(input: $input, condition: $condition) {
      id
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentsId
          postsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      postUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      rootPostId
      refrencePostId
      cardItemID
      postType
      likes {
        items {
          id
          status
          createdAt
          updatedAt
          userProfileDetailsLikesId
          postsLikesId
          __typename
        }
        nextToken
        __typename
      }
      views {
        items {
          id
          ipAddress
          status
          createdAt
          updatedAt
          userProfileDetailsViewsId
          postsViewsId
          __typename
        }
        nextToken
        __typename
      }
      quizResults {
        items {
          id
          iSpringID
          quizCategory
          quizLevel
          quizTitle
          quizGrade
          quizSeqNo
          totalScore
          quizScore
          status
          createdAt
          updatedAt
          userProfileDetailsQuizResultsId
          postsQuizResultsId
          __typename
        }
        nextToken
        __typename
      }
      postCategories {
        items {
          id
          createdAt
          updatedAt
          postsPostCategoriesId
          categoriesPostCategoriesId
          __typename
        }
        nextToken
        __typename
      }
      studentModuleQuestionResult {
        items {
          id
          iSpringID
          moduleCategory
          moduleLevel
          moduleTitle
          moduleGrade
          moduleSeqNo
          questionIndex
          questionText
          totalScore
          schoolName
          schoolLocation
          userAnswer
          creatorEmail
          Status
          correctAnswer
          pointsAllotted
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsModuleStudentQuestionResultId
          postsStudentModuleQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsPostsId
      __typename
    }
  }
`;
export const updatePosts = /* GraphQL */ `
  mutation UpdatePosts(
    $input: UpdatePostsInput!
    $condition: ModelPostsConditionInput
  ) {
    updatePosts(input: $input, condition: $condition) {
      id
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentsId
          postsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      postUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      rootPostId
      refrencePostId
      cardItemID
      postType
      likes {
        items {
          id
          status
          createdAt
          updatedAt
          userProfileDetailsLikesId
          postsLikesId
          __typename
        }
        nextToken
        __typename
      }
      views {
        items {
          id
          ipAddress
          status
          createdAt
          updatedAt
          userProfileDetailsViewsId
          postsViewsId
          __typename
        }
        nextToken
        __typename
      }
      quizResults {
        items {
          id
          iSpringID
          quizCategory
          quizLevel
          quizTitle
          quizGrade
          quizSeqNo
          totalScore
          quizScore
          status
          createdAt
          updatedAt
          userProfileDetailsQuizResultsId
          postsQuizResultsId
          __typename
        }
        nextToken
        __typename
      }
      postCategories {
        items {
          id
          createdAt
          updatedAt
          postsPostCategoriesId
          categoriesPostCategoriesId
          __typename
        }
        nextToken
        __typename
      }
      studentModuleQuestionResult {
        items {
          id
          iSpringID
          moduleCategory
          moduleLevel
          moduleTitle
          moduleGrade
          moduleSeqNo
          questionIndex
          questionText
          totalScore
          schoolName
          schoolLocation
          userAnswer
          creatorEmail
          Status
          correctAnswer
          pointsAllotted
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsModuleStudentQuestionResultId
          postsStudentModuleQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsPostsId
      __typename
    }
  }
`;
export const deletePosts = /* GraphQL */ `
  mutation DeletePosts(
    $input: DeletePostsInput!
    $condition: ModelPostsConditionInput
  ) {
    deletePosts(input: $input, condition: $condition) {
      id
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentsId
          postsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      postUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      rootPostId
      refrencePostId
      cardItemID
      postType
      likes {
        items {
          id
          status
          createdAt
          updatedAt
          userProfileDetailsLikesId
          postsLikesId
          __typename
        }
        nextToken
        __typename
      }
      views {
        items {
          id
          ipAddress
          status
          createdAt
          updatedAt
          userProfileDetailsViewsId
          postsViewsId
          __typename
        }
        nextToken
        __typename
      }
      quizResults {
        items {
          id
          iSpringID
          quizCategory
          quizLevel
          quizTitle
          quizGrade
          quizSeqNo
          totalScore
          quizScore
          status
          createdAt
          updatedAt
          userProfileDetailsQuizResultsId
          postsQuizResultsId
          __typename
        }
        nextToken
        __typename
      }
      postCategories {
        items {
          id
          createdAt
          updatedAt
          postsPostCategoriesId
          categoriesPostCategoriesId
          __typename
        }
        nextToken
        __typename
      }
      studentModuleQuestionResult {
        items {
          id
          iSpringID
          moduleCategory
          moduleLevel
          moduleTitle
          moduleGrade
          moduleSeqNo
          questionIndex
          questionText
          totalScore
          schoolName
          schoolLocation
          userAnswer
          creatorEmail
          Status
          correctAnswer
          pointsAllotted
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsModuleStudentQuestionResultId
          postsStudentModuleQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsPostsId
      __typename
    }
  }
`;
export const createComments = /* GraphQL */ `
  mutation CreateComments(
    $input: CreateCommentsInput!
    $condition: ModelCommentsConditionInput
  ) {
    createComments(input: $input, condition: $condition) {
      id
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentOneId
          commentsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      commentUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      message
      createdAt
      updatedAt
      userProfileDetailsCommentsId
      postsCommentsId
      __typename
    }
  }
`;
export const updateComments = /* GraphQL */ `
  mutation UpdateComments(
    $input: UpdateCommentsInput!
    $condition: ModelCommentsConditionInput
  ) {
    updateComments(input: $input, condition: $condition) {
      id
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentOneId
          commentsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      commentUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      message
      createdAt
      updatedAt
      userProfileDetailsCommentsId
      postsCommentsId
      __typename
    }
  }
`;
export const deleteComments = /* GraphQL */ `
  mutation DeleteComments(
    $input: DeleteCommentsInput!
    $condition: ModelCommentsConditionInput
  ) {
    deleteComments(input: $input, condition: $condition) {
      id
      comments {
        items {
          id
          message
          createdAt
          updatedAt
          userProfileDetailsCommentOneId
          commentsCommentsId
          __typename
        }
        nextToken
        __typename
      }
      commentUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      message
      createdAt
      updatedAt
      userProfileDetailsCommentsId
      postsCommentsId
      __typename
    }
  }
`;
export const createCommentOne = /* GraphQL */ `
  mutation CreateCommentOne(
    $input: CreateCommentOneInput!
    $condition: ModelCommentOneConditionInput
  ) {
    createCommentOne(input: $input, condition: $condition) {
      id
      commentUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      message
      createdAt
      updatedAt
      userProfileDetailsCommentOneId
      commentsCommentsId
      __typename
    }
  }
`;
export const updateCommentOne = /* GraphQL */ `
  mutation UpdateCommentOne(
    $input: UpdateCommentOneInput!
    $condition: ModelCommentOneConditionInput
  ) {
    updateCommentOne(input: $input, condition: $condition) {
      id
      commentUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      message
      createdAt
      updatedAt
      userProfileDetailsCommentOneId
      commentsCommentsId
      __typename
    }
  }
`;
export const deleteCommentOne = /* GraphQL */ `
  mutation DeleteCommentOne(
    $input: DeleteCommentOneInput!
    $condition: ModelCommentOneConditionInput
  ) {
    deleteCommentOne(input: $input, condition: $condition) {
      id
      commentUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      message
      createdAt
      updatedAt
      userProfileDetailsCommentOneId
      commentsCommentsId
      __typename
    }
  }
`;
export const createLikes = /* GraphQL */ `
  mutation CreateLikes(
    $input: CreateLikesInput!
    $condition: ModelLikesConditionInput
  ) {
    createLikes(input: $input, condition: $condition) {
      id
      likeUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      status
      createdAt
      updatedAt
      userProfileDetailsLikesId
      postsLikesId
      __typename
    }
  }
`;
export const updateLikes = /* GraphQL */ `
  mutation UpdateLikes(
    $input: UpdateLikesInput!
    $condition: ModelLikesConditionInput
  ) {
    updateLikes(input: $input, condition: $condition) {
      id
      likeUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      status
      createdAt
      updatedAt
      userProfileDetailsLikesId
      postsLikesId
      __typename
    }
  }
`;
export const deleteLikes = /* GraphQL */ `
  mutation DeleteLikes(
    $input: DeleteLikesInput!
    $condition: ModelLikesConditionInput
  ) {
    deleteLikes(input: $input, condition: $condition) {
      id
      likeUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      status
      createdAt
      updatedAt
      userProfileDetailsLikesId
      postsLikesId
      __typename
    }
  }
`;
export const createPostViews = /* GraphQL */ `
  mutation CreatePostViews(
    $input: CreatePostViewsInput!
    $condition: ModelPostViewsConditionInput
  ) {
    createPostViews(input: $input, condition: $condition) {
      id
      viewUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      ipAddress
      status
      createdAt
      updatedAt
      userProfileDetailsViewsId
      postsViewsId
      __typename
    }
  }
`;
export const updatePostViews = /* GraphQL */ `
  mutation UpdatePostViews(
    $input: UpdatePostViewsInput!
    $condition: ModelPostViewsConditionInput
  ) {
    updatePostViews(input: $input, condition: $condition) {
      id
      viewUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      ipAddress
      status
      createdAt
      updatedAt
      userProfileDetailsViewsId
      postsViewsId
      __typename
    }
  }
`;
export const deletePostViews = /* GraphQL */ `
  mutation DeletePostViews(
    $input: DeletePostViewsInput!
    $condition: ModelPostViewsConditionInput
  ) {
    deletePostViews(input: $input, condition: $condition) {
      id
      viewUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      ipAddress
      status
      createdAt
      updatedAt
      userProfileDetailsViewsId
      postsViewsId
      __typename
    }
  }
`;
export const createQuizResults = /* GraphQL */ `
  mutation CreateQuizResults(
    $input: CreateQuizResultsInput!
    $condition: ModelQuizResultsConditionInput
  ) {
    createQuizResults(input: $input, condition: $condition) {
      id
      quizUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      iSpringID
      quizCategory
      quizLevel
      quizTitle
      quizGrade
      quizSeqNo
      totalScore
      quizScore
      status
      createdAt
      updatedAt
      userProfileDetailsQuizResultsId
      postsQuizResultsId
      __typename
    }
  }
`;
export const updateQuizResults = /* GraphQL */ `
  mutation UpdateQuizResults(
    $input: UpdateQuizResultsInput!
    $condition: ModelQuizResultsConditionInput
  ) {
    updateQuizResults(input: $input, condition: $condition) {
      id
      quizUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      iSpringID
      quizCategory
      quizLevel
      quizTitle
      quizGrade
      quizSeqNo
      totalScore
      quizScore
      status
      createdAt
      updatedAt
      userProfileDetailsQuizResultsId
      postsQuizResultsId
      __typename
    }
  }
`;
export const deleteQuizResults = /* GraphQL */ `
  mutation DeleteQuizResults(
    $input: DeleteQuizResultsInput!
    $condition: ModelQuizResultsConditionInput
  ) {
    deleteQuizResults(input: $input, condition: $condition) {
      id
      quizUserID {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      iSpringID
      quizCategory
      quizLevel
      quizTitle
      quizGrade
      quizSeqNo
      totalScore
      quizScore
      status
      createdAt
      updatedAt
      userProfileDetailsQuizResultsId
      postsQuizResultsId
      __typename
    }
  }
`;
export const createCategories = /* GraphQL */ `
  mutation CreateCategories(
    $input: CreateCategoriesInput!
    $condition: ModelCategoriesConditionInput
  ) {
    createCategories(input: $input, condition: $condition) {
      id
      name
      slug
      status
      postCategories {
        items {
          id
          createdAt
          updatedAt
          postsPostCategoriesId
          categoriesPostCategoriesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCategories = /* GraphQL */ `
  mutation UpdateCategories(
    $input: UpdateCategoriesInput!
    $condition: ModelCategoriesConditionInput
  ) {
    updateCategories(input: $input, condition: $condition) {
      id
      name
      slug
      status
      postCategories {
        items {
          id
          createdAt
          updatedAt
          postsPostCategoriesId
          categoriesPostCategoriesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCategories = /* GraphQL */ `
  mutation DeleteCategories(
    $input: DeleteCategoriesInput!
    $condition: ModelCategoriesConditionInput
  ) {
    deleteCategories(input: $input, condition: $condition) {
      id
      name
      slug
      status
      postCategories {
        items {
          id
          createdAt
          updatedAt
          postsPostCategoriesId
          categoriesPostCategoriesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPostCategories = /* GraphQL */ `
  mutation CreatePostCategories(
    $input: CreatePostCategoriesInput!
    $condition: ModelPostCategoriesConditionInput
  ) {
    createPostCategories(input: $input, condition: $condition) {
      id
      postID {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      categoryID {
        id
        name
        slug
        status
        postCategories {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      postsPostCategoriesId
      categoriesPostCategoriesId
      __typename
    }
  }
`;
export const updatePostCategories = /* GraphQL */ `
  mutation UpdatePostCategories(
    $input: UpdatePostCategoriesInput!
    $condition: ModelPostCategoriesConditionInput
  ) {
    updatePostCategories(input: $input, condition: $condition) {
      id
      postID {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      categoryID {
        id
        name
        slug
        status
        postCategories {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      postsPostCategoriesId
      categoriesPostCategoriesId
      __typename
    }
  }
`;
export const deletePostCategories = /* GraphQL */ `
  mutation DeletePostCategories(
    $input: DeletePostCategoriesInput!
    $condition: ModelPostCategoriesConditionInput
  ) {
    deletePostCategories(input: $input, condition: $condition) {
      id
      postID {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      categoryID {
        id
        name
        slug
        status
        postCategories {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      postsPostCategoriesId
      categoriesPostCategoriesId
      __typename
    }
  }
`;
export const createUserAccessRole = /* GraphQL */ `
  mutation CreateUserAccessRole(
    $input: CreateUserAccessRoleInput!
    $condition: ModelUserAccessRoleConditionInput
  ) {
    createUserAccessRole(input: $input, condition: $condition) {
      id
      isMobileVerified
      isParentVerified
      isSelfEmailVerified
      isMinor
      isDisabled
      userStatus
      userStatusLabel
      priority
      canLogin
      canViewSelfProfile
      canViewOthersProfile
      canEditSelfProfile
      CanEditAccInfo
      canAddMentor
      canAddProjects
      canViewOtherProject
      canCreateCV
      canShareCV
      canViewOtherCV
      canMakeConnections
      canSearchConnections
      canAddDairy
      canEditDairy
      canDeleteDairy
      canAddBlog
      canEditBlog
      canDeleteBlog
      canViewBlog
      enableMobileVerification
      enableParentalVerification
      enableSelfEmailVerification
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserAccessRole = /* GraphQL */ `
  mutation UpdateUserAccessRole(
    $input: UpdateUserAccessRoleInput!
    $condition: ModelUserAccessRoleConditionInput
  ) {
    updateUserAccessRole(input: $input, condition: $condition) {
      id
      isMobileVerified
      isParentVerified
      isSelfEmailVerified
      isMinor
      isDisabled
      userStatus
      userStatusLabel
      priority
      canLogin
      canViewSelfProfile
      canViewOthersProfile
      canEditSelfProfile
      CanEditAccInfo
      canAddMentor
      canAddProjects
      canViewOtherProject
      canCreateCV
      canShareCV
      canViewOtherCV
      canMakeConnections
      canSearchConnections
      canAddDairy
      canEditDairy
      canDeleteDairy
      canAddBlog
      canEditBlog
      canDeleteBlog
      canViewBlog
      enableMobileVerification
      enableParentalVerification
      enableSelfEmailVerification
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserAccessRole = /* GraphQL */ `
  mutation DeleteUserAccessRole(
    $input: DeleteUserAccessRoleInput!
    $condition: ModelUserAccessRoleConditionInput
  ) {
    deleteUserAccessRole(input: $input, condition: $condition) {
      id
      isMobileVerified
      isParentVerified
      isSelfEmailVerified
      isMinor
      isDisabled
      userStatus
      userStatusLabel
      priority
      canLogin
      canViewSelfProfile
      canViewOthersProfile
      canEditSelfProfile
      CanEditAccInfo
      canAddMentor
      canAddProjects
      canViewOtherProject
      canCreateCV
      canShareCV
      canViewOtherCV
      canMakeConnections
      canSearchConnections
      canAddDairy
      canEditDairy
      canDeleteDairy
      canAddBlog
      canEditBlog
      canDeleteBlog
      canViewBlog
      enableMobileVerification
      enableParentalVerification
      enableSelfEmailVerification
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInterest = /* GraphQL */ `
  mutation CreateInterest(
    $input: CreateInterestInput!
    $condition: ModelInterestConditionInput
  ) {
    createInterest(input: $input, condition: $condition) {
      id
      name
      image
      subinterests {
        items {
          id
          name
          image
          interestID
          createdAt
          updatedAt
          interestSubinterestsId
          __typename
        }
        nextToken
        __typename
      }
      Users {
        items {
          id
          userInterestID
          interestID
          createdAt
          updatedAt
          userProfileDetailsInterestsId
          interestUsersId
          __typename
        }
        nextToken
        __typename
      }
      orderBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInterest = /* GraphQL */ `
  mutation UpdateInterest(
    $input: UpdateInterestInput!
    $condition: ModelInterestConditionInput
  ) {
    updateInterest(input: $input, condition: $condition) {
      id
      name
      image
      subinterests {
        items {
          id
          name
          image
          interestID
          createdAt
          updatedAt
          interestSubinterestsId
          __typename
        }
        nextToken
        __typename
      }
      Users {
        items {
          id
          userInterestID
          interestID
          createdAt
          updatedAt
          userProfileDetailsInterestsId
          interestUsersId
          __typename
        }
        nextToken
        __typename
      }
      orderBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInterest = /* GraphQL */ `
  mutation DeleteInterest(
    $input: DeleteInterestInput!
    $condition: ModelInterestConditionInput
  ) {
    deleteInterest(input: $input, condition: $condition) {
      id
      name
      image
      subinterests {
        items {
          id
          name
          image
          interestID
          createdAt
          updatedAt
          interestSubinterestsId
          __typename
        }
        nextToken
        __typename
      }
      Users {
        items {
          id
          userInterestID
          interestID
          createdAt
          updatedAt
          userProfileDetailsInterestsId
          interestUsersId
          __typename
        }
        nextToken
        __typename
      }
      orderBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSubinterest = /* GraphQL */ `
  mutation CreateSubinterest(
    $input: CreateSubinterestInput!
    $condition: ModelSubinterestConditionInput
  ) {
    createSubinterest(input: $input, condition: $condition) {
      id
      name
      image
      interestID
      interest {
        id
        name
        image
        subinterests {
          nextToken
          __typename
        }
        Users {
          nextToken
          __typename
        }
        orderBy
        createdAt
        updatedAt
        __typename
      }
      Users {
        items {
          id
          userInterestID
          subinterestID
          createdAt
          updatedAt
          userProfileDetailsSubinterestsId
          subinterestUsersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      interestSubinterestsId
      __typename
    }
  }
`;
export const updateSubinterest = /* GraphQL */ `
  mutation UpdateSubinterest(
    $input: UpdateSubinterestInput!
    $condition: ModelSubinterestConditionInput
  ) {
    updateSubinterest(input: $input, condition: $condition) {
      id
      name
      image
      interestID
      interest {
        id
        name
        image
        subinterests {
          nextToken
          __typename
        }
        Users {
          nextToken
          __typename
        }
        orderBy
        createdAt
        updatedAt
        __typename
      }
      Users {
        items {
          id
          userInterestID
          subinterestID
          createdAt
          updatedAt
          userProfileDetailsSubinterestsId
          subinterestUsersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      interestSubinterestsId
      __typename
    }
  }
`;
export const deleteSubinterest = /* GraphQL */ `
  mutation DeleteSubinterest(
    $input: DeleteSubinterestInput!
    $condition: ModelSubinterestConditionInput
  ) {
    deleteSubinterest(input: $input, condition: $condition) {
      id
      name
      image
      interestID
      interest {
        id
        name
        image
        subinterests {
          nextToken
          __typename
        }
        Users {
          nextToken
          __typename
        }
        orderBy
        createdAt
        updatedAt
        __typename
      }
      Users {
        items {
          id
          userInterestID
          subinterestID
          createdAt
          updatedAt
          userProfileDetailsSubinterestsId
          subinterestUsersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      interestSubinterestsId
      __typename
    }
  }
`;
export const createInterestUser = /* GraphQL */ `
  mutation CreateInterestUser(
    $input: CreateInterestUserInput!
    $condition: ModelInterestUserConditionInput
  ) {
    createInterestUser(input: $input, condition: $condition) {
      id
      userInterestID
      interestID
      interest {
        id
        name
        image
        subinterests {
          nextToken
          __typename
        }
        Users {
          nextToken
          __typename
        }
        orderBy
        createdAt
        updatedAt
        __typename
      }
      user {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsInterestsId
      interestUsersId
      __typename
    }
  }
`;
export const updateInterestUser = /* GraphQL */ `
  mutation UpdateInterestUser(
    $input: UpdateInterestUserInput!
    $condition: ModelInterestUserConditionInput
  ) {
    updateInterestUser(input: $input, condition: $condition) {
      id
      userInterestID
      interestID
      interest {
        id
        name
        image
        subinterests {
          nextToken
          __typename
        }
        Users {
          nextToken
          __typename
        }
        orderBy
        createdAt
        updatedAt
        __typename
      }
      user {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsInterestsId
      interestUsersId
      __typename
    }
  }
`;
export const deleteInterestUser = /* GraphQL */ `
  mutation DeleteInterestUser(
    $input: DeleteInterestUserInput!
    $condition: ModelInterestUserConditionInput
  ) {
    deleteInterestUser(input: $input, condition: $condition) {
      id
      userInterestID
      interestID
      interest {
        id
        name
        image
        subinterests {
          nextToken
          __typename
        }
        Users {
          nextToken
          __typename
        }
        orderBy
        createdAt
        updatedAt
        __typename
      }
      user {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsInterestsId
      interestUsersId
      __typename
    }
  }
`;
export const createSubinterestUser = /* GraphQL */ `
  mutation CreateSubinterestUser(
    $input: CreateSubinterestUserInput!
    $condition: ModelSubinterestUserConditionInput
  ) {
    createSubinterestUser(input: $input, condition: $condition) {
      id
      userInterestID
      subinterestID
      user {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      subinterest {
        id
        name
        image
        interestID
        interest {
          id
          name
          image
          orderBy
          createdAt
          updatedAt
          __typename
        }
        Users {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interestSubinterestsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsSubinterestsId
      subinterestUsersId
      __typename
    }
  }
`;
export const updateSubinterestUser = /* GraphQL */ `
  mutation UpdateSubinterestUser(
    $input: UpdateSubinterestUserInput!
    $condition: ModelSubinterestUserConditionInput
  ) {
    updateSubinterestUser(input: $input, condition: $condition) {
      id
      userInterestID
      subinterestID
      user {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      subinterest {
        id
        name
        image
        interestID
        interest {
          id
          name
          image
          orderBy
          createdAt
          updatedAt
          __typename
        }
        Users {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interestSubinterestsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsSubinterestsId
      subinterestUsersId
      __typename
    }
  }
`;
export const deleteSubinterestUser = /* GraphQL */ `
  mutation DeleteSubinterestUser(
    $input: DeleteSubinterestUserInput!
    $condition: ModelSubinterestUserConditionInput
  ) {
    deleteSubinterestUser(input: $input, condition: $condition) {
      id
      userInterestID
      subinterestID
      user {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      subinterest {
        id
        name
        image
        interestID
        interest {
          id
          name
          image
          orderBy
          createdAt
          updatedAt
          __typename
        }
        Users {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interestSubinterestsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsSubinterestsId
      subinterestUsersId
      __typename
    }
  }
`;
export const createDashboardSummary = /* GraphQL */ `
  mutation CreateDashboardSummary(
    $input: CreateDashboardSummaryInput!
    $condition: ModelDashboardSummaryConditionInput
  ) {
    createDashboardSummary(input: $input, condition: $condition) {
      id
      totalUsers
      yesterdaysUsers
      totalProfile
      yesterdaysProfile
      totalProjects
      yesterdaysProjects
      totalCvs
      yesterdaysCvs
      totalConnections
      yesterdaysConnections
      totalAccomplishments
      yesterdaysAccomplishments
      totalSAccomplishments
      yesterdaysSAccomplishments
      totalLogins
      yesterdaysLogins
      totalUM
      totalUEMM
      totalFA
      totalPCM
      totalPMM
      totalUEM
      totalUMM
      totalDisabled
      perUM
      perUEMM
      perFA
      perPCM
      perPMM
      perUEM
      perUMM
      perDisabled
      totalUserInterests
      yesterdaysUserInterests
      totalUserSubInterests
      yesterdaysUserSubInterests
      totalInterestsUsers
      yesterdaysInterestsUsers
      totalCvsUser
      yesterdaysCvsUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDashboardSummary = /* GraphQL */ `
  mutation UpdateDashboardSummary(
    $input: UpdateDashboardSummaryInput!
    $condition: ModelDashboardSummaryConditionInput
  ) {
    updateDashboardSummary(input: $input, condition: $condition) {
      id
      totalUsers
      yesterdaysUsers
      totalProfile
      yesterdaysProfile
      totalProjects
      yesterdaysProjects
      totalCvs
      yesterdaysCvs
      totalConnections
      yesterdaysConnections
      totalAccomplishments
      yesterdaysAccomplishments
      totalSAccomplishments
      yesterdaysSAccomplishments
      totalLogins
      yesterdaysLogins
      totalUM
      totalUEMM
      totalFA
      totalPCM
      totalPMM
      totalUEM
      totalUMM
      totalDisabled
      perUM
      perUEMM
      perFA
      perPCM
      perPMM
      perUEM
      perUMM
      perDisabled
      totalUserInterests
      yesterdaysUserInterests
      totalUserSubInterests
      yesterdaysUserSubInterests
      totalInterestsUsers
      yesterdaysInterestsUsers
      totalCvsUser
      yesterdaysCvsUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDashboardSummary = /* GraphQL */ `
  mutation DeleteDashboardSummary(
    $input: DeleteDashboardSummaryInput!
    $condition: ModelDashboardSummaryConditionInput
  ) {
    deleteDashboardSummary(input: $input, condition: $condition) {
      id
      totalUsers
      yesterdaysUsers
      totalProfile
      yesterdaysProfile
      totalProjects
      yesterdaysProjects
      totalCvs
      yesterdaysCvs
      totalConnections
      yesterdaysConnections
      totalAccomplishments
      yesterdaysAccomplishments
      totalSAccomplishments
      yesterdaysSAccomplishments
      totalLogins
      yesterdaysLogins
      totalUM
      totalUEMM
      totalFA
      totalPCM
      totalPMM
      totalUEM
      totalUMM
      totalDisabled
      perUM
      perUEMM
      perFA
      perPCM
      perPMM
      perUEM
      perUMM
      perDisabled
      totalUserInterests
      yesterdaysUserInterests
      totalUserSubInterests
      yesterdaysUserSubInterests
      totalInterestsUsers
      yesterdaysInterestsUsers
      totalCvsUser
      yesterdaysCvsUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuizDetails = /* GraphQL */ `
  mutation CreateQuizDetails(
    $input: CreateQuizDetailsInput!
    $condition: ModelQuizDetailsConditionInput
  ) {
    createQuizDetails(input: $input, condition: $condition) {
      id
      title
      interest
      subinterest
      level
      creatorEmail
      type
      questions {
        items {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          quizDetailsQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      questionTimeLimit
      intimationQuestionText
      quizInstances {
        items {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          quizDetailsQuizInstancesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuizDetails = /* GraphQL */ `
  mutation UpdateQuizDetails(
    $input: UpdateQuizDetailsInput!
    $condition: ModelQuizDetailsConditionInput
  ) {
    updateQuizDetails(input: $input, condition: $condition) {
      id
      title
      interest
      subinterest
      level
      creatorEmail
      type
      questions {
        items {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          quizDetailsQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      questionTimeLimit
      intimationQuestionText
      quizInstances {
        items {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          quizDetailsQuizInstancesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuizDetails = /* GraphQL */ `
  mutation DeleteQuizDetails(
    $input: DeleteQuizDetailsInput!
    $condition: ModelQuizDetailsConditionInput
  ) {
    deleteQuizDetails(input: $input, condition: $condition) {
      id
      title
      interest
      subinterest
      level
      creatorEmail
      type
      questions {
        items {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          quizDetailsQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      questionTimeLimit
      intimationQuestionText
      quizInstances {
        items {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          quizDetailsQuizInstancesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuizQuestionOptions = /* GraphQL */ `
  mutation CreateQuizQuestionOptions(
    $input: CreateQuizQuestionOptionsInput!
    $condition: ModelQuizQuestionOptionsConditionInput
  ) {
    createQuizQuestionOptions(input: $input, condition: $condition) {
      id
      indexKey
      indexValue
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      createdAt
      updatedAt
      quizQuestionsQuizQuestionOptionsId
      __typename
    }
  }
`;
export const updateQuizQuestionOptions = /* GraphQL */ `
  mutation UpdateQuizQuestionOptions(
    $input: UpdateQuizQuestionOptionsInput!
    $condition: ModelQuizQuestionOptionsConditionInput
  ) {
    updateQuizQuestionOptions(input: $input, condition: $condition) {
      id
      indexKey
      indexValue
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      createdAt
      updatedAt
      quizQuestionsQuizQuestionOptionsId
      __typename
    }
  }
`;
export const deleteQuizQuestionOptions = /* GraphQL */ `
  mutation DeleteQuizQuestionOptions(
    $input: DeleteQuizQuestionOptionsInput!
    $condition: ModelQuizQuestionOptionsConditionInput
  ) {
    deleteQuizQuestionOptions(input: $input, condition: $condition) {
      id
      indexKey
      indexValue
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      createdAt
      updatedAt
      quizQuestionsQuizQuestionOptionsId
      __typename
    }
  }
`;
export const createQuizQuestions = /* GraphQL */ `
  mutation CreateQuizQuestions(
    $input: CreateQuizQuestionsInput!
    $condition: ModelQuizQuestionsConditionInput
  ) {
    createQuizQuestions(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      index
      text
      QuizQuestionOptions {
        items {
          id
          indexKey
          indexValue
          createdAt
          updatedAt
          quizQuestionsQuizQuestionOptionsId
          __typename
        }
        nextToken
        __typename
      }
      points
      correctAnswer
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      quizDetailsQuestionsId
      __typename
    }
  }
`;
export const updateQuizQuestions = /* GraphQL */ `
  mutation UpdateQuizQuestions(
    $input: UpdateQuizQuestionsInput!
    $condition: ModelQuizQuestionsConditionInput
  ) {
    updateQuizQuestions(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      index
      text
      QuizQuestionOptions {
        items {
          id
          indexKey
          indexValue
          createdAt
          updatedAt
          quizQuestionsQuizQuestionOptionsId
          __typename
        }
        nextToken
        __typename
      }
      points
      correctAnswer
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      quizDetailsQuestionsId
      __typename
    }
  }
`;
export const deleteQuizQuestions = /* GraphQL */ `
  mutation DeleteQuizQuestions(
    $input: DeleteQuizQuestionsInput!
    $condition: ModelQuizQuestionsConditionInput
  ) {
    deleteQuizQuestions(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      index
      text
      QuizQuestionOptions {
        items {
          id
          indexKey
          indexValue
          createdAt
          updatedAt
          quizQuestionsQuizQuestionOptionsId
          __typename
        }
        nextToken
        __typename
      }
      points
      correctAnswer
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      quizDetailsQuestionsId
      __typename
    }
  }
`;
export const createQuizInstance = /* GraphQL */ `
  mutation CreateQuizInstance(
    $input: CreateQuizInstanceInput!
    $condition: ModelQuizInstanceConditionInput
  ) {
    createQuizInstance(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      sendResult
      isResultSent
      resultSendTime
      isStarted
      startTime
      isEnded
      medium
      endTime
      isInstituteBased
      instituteName
      quizInstanceStudents {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          userProfileDetailsQuizStudentId
          quizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      quizDetailsQuizInstancesId
      __typename
    }
  }
`;
export const updateQuizInstance = /* GraphQL */ `
  mutation UpdateQuizInstance(
    $input: UpdateQuizInstanceInput!
    $condition: ModelQuizInstanceConditionInput
  ) {
    updateQuizInstance(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      sendResult
      isResultSent
      resultSendTime
      isStarted
      startTime
      isEnded
      medium
      endTime
      isInstituteBased
      instituteName
      quizInstanceStudents {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          userProfileDetailsQuizStudentId
          quizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      quizDetailsQuizInstancesId
      __typename
    }
  }
`;
export const deleteQuizInstance = /* GraphQL */ `
  mutation DeleteQuizInstance(
    $input: DeleteQuizInstanceInput!
    $condition: ModelQuizInstanceConditionInput
  ) {
    deleteQuizInstance(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      sendResult
      isResultSent
      resultSendTime
      isStarted
      startTime
      isEnded
      medium
      endTime
      isInstituteBased
      instituteName
      quizInstanceStudents {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          userProfileDetailsQuizStudentId
          quizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          userProfileDetailsQuizStudentQuestionResultId
          quizQuestionsQuizStudentQuestionResultId
          quizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      quizDetailsQuizInstancesId
      __typename
    }
  }
`;
export const createQuizStudent = /* GraphQL */ `
  mutation CreateQuizStudent(
    $input: CreateQuizStudentInput!
    $condition: ModelQuizStudentConditionInput
  ) {
    createQuizStudent(input: $input, condition: $condition) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      isParticipating
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsQuizStudentId
      quizInstanceQuizInstanceStudentsId
      __typename
    }
  }
`;
export const updateQuizStudent = /* GraphQL */ `
  mutation UpdateQuizStudent(
    $input: UpdateQuizStudentInput!
    $condition: ModelQuizStudentConditionInput
  ) {
    updateQuizStudent(input: $input, condition: $condition) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      isParticipating
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsQuizStudentId
      quizInstanceQuizInstanceStudentsId
      __typename
    }
  }
`;
export const deleteQuizStudent = /* GraphQL */ `
  mutation DeleteQuizStudent(
    $input: DeleteQuizStudentInput!
    $condition: ModelQuizStudentConditionInput
  ) {
    deleteQuizStudent(input: $input, condition: $condition) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      isParticipating
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      userProfileDetailsQuizStudentId
      quizInstanceQuizInstanceStudentsId
      __typename
    }
  }
`;
export const createQuizStudentQuestionResult = /* GraphQL */ `
  mutation CreateQuizStudentQuestionResult(
    $input: CreateQuizStudentQuestionResultInput!
    $condition: ModelQuizStudentQuestionResultConditionInput
  ) {
    createQuizStudentQuestionResult(input: $input, condition: $condition) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      answerReceived
      pointsEarned
      createdAt
      updatedAt
      userProfileDetailsQuizStudentQuestionResultId
      quizQuestionsQuizStudentQuestionResultId
      quizInstanceQuizStudentQuestionResultId
      __typename
    }
  }
`;
export const updateQuizStudentQuestionResult = /* GraphQL */ `
  mutation UpdateQuizStudentQuestionResult(
    $input: UpdateQuizStudentQuestionResultInput!
    $condition: ModelQuizStudentQuestionResultConditionInput
  ) {
    updateQuizStudentQuestionResult(input: $input, condition: $condition) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      answerReceived
      pointsEarned
      createdAt
      updatedAt
      userProfileDetailsQuizStudentQuestionResultId
      quizQuestionsQuizStudentQuestionResultId
      quizInstanceQuizStudentQuestionResultId
      __typename
    }
  }
`;
export const deleteQuizStudentQuestionResult = /* GraphQL */ `
  mutation DeleteQuizStudentQuestionResult(
    $input: DeleteQuizStudentQuestionResultInput!
    $condition: ModelQuizStudentQuestionResultConditionInput
  ) {
    deleteQuizStudentQuestionResult(input: $input, condition: $condition) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        quizDetailsQuizInstancesId
        __typename
      }
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        quizDetailsQuestionsId
        __typename
      }
      userId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      answerReceived
      pointsEarned
      createdAt
      updatedAt
      userProfileDetailsQuizStudentQuestionResultId
      quizQuestionsQuizStudentQuestionResultId
      quizInstanceQuizStudentQuestionResultId
      __typename
    }
  }
`;
export const createModuleStudentQuestionResult = /* GraphQL */ `
  mutation CreateModuleStudentQuestionResult(
    $input: CreateModuleStudentQuestionResultInput!
    $condition: ModelModuleStudentQuestionResultConditionInput
  ) {
    createModuleStudentQuestionResult(input: $input, condition: $condition) {
      id
      moduleUserId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      postId {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      iSpringID
      moduleCategory
      moduleLevel
      moduleTitle
      moduleGrade
      moduleSeqNo
      questionIndex
      questionText
      totalScore
      schoolName
      schoolLocation
      userAnswer
      creatorEmail
      Status
      correctAnswer
      pointsAllotted
      pointsEarned
      createdAt
      updatedAt
      userProfileDetailsModuleStudentQuestionResultId
      postsStudentModuleQuestionResultId
      __typename
    }
  }
`;
export const updateModuleStudentQuestionResult = /* GraphQL */ `
  mutation UpdateModuleStudentQuestionResult(
    $input: UpdateModuleStudentQuestionResultInput!
    $condition: ModelModuleStudentQuestionResultConditionInput
  ) {
    updateModuleStudentQuestionResult(input: $input, condition: $condition) {
      id
      moduleUserId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      postId {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      iSpringID
      moduleCategory
      moduleLevel
      moduleTitle
      moduleGrade
      moduleSeqNo
      questionIndex
      questionText
      totalScore
      schoolName
      schoolLocation
      userAnswer
      creatorEmail
      Status
      correctAnswer
      pointsAllotted
      pointsEarned
      createdAt
      updatedAt
      userProfileDetailsModuleStudentQuestionResultId
      postsStudentModuleQuestionResultId
      __typename
    }
  }
`;
export const deleteModuleStudentQuestionResult = /* GraphQL */ `
  mutation DeleteModuleStudentQuestionResult(
    $input: DeleteModuleStudentQuestionResultInput!
    $condition: ModelModuleStudentQuestionResultConditionInput
  ) {
    deleteModuleStudentQuestionResult(input: $input, condition: $condition) {
      id
      moduleUserId {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      postId {
        id
        comments {
          nextToken
          __typename
        }
        postUserID {
          about_me
          about_restriction
          bg_image
          career_goal
          city
          cnt_views
          cv_data
          country
          cvs
          dob
          first_name
          gender
          id
          job
          languages
          last_name
          links
          loginAt
          middle_name
          mobile_no
          parent_email
          parent_mobile
          parent_name
          profile_avatar
          profile_complition
          profile_image
          projects
          projects_data
          referralCode
          school_name
          accomplishment_data
          connection_data
          skipMobileVerification
          skipParentalconsent
          isMobileVerified
          isParentVerified
          isSelfEmailVerified
          isparentRequestSent
          mobileSmsTriggerCnt
          selfEmailTriggerCnt
          parentRequestSentTriggerCnt
          welcomeEmailSentCnt
          mobileSmsTriggerDt
          selfEmailTriggerDt
          parentRequestSentTriggerDt
          welcomeEmailSentDt
          mobileReminderSmsTriggerCnt
          mobileReminderSmsTriggerDt
          mobileCountrycode
          parentmobileCountrycode
          isTestUser
          source
          isAdmin
          adminSchoolName
          adminCompanyName
          adminIssuingOrganisation
          adminAccomplishmentsProvider
          adminMembershipOrganisation
          adminLogo
          state
          tblrolemappingID
          userProfileDetailsUserMasterId
          userType
          username
          registeredDate
          adminSchoolType
          quizAvgScore
          connectedInstituteAdmins
          createdAt
          updatedAt
          userMasterUserProfileDetailsId
          __typename
        }
        rootPostId
        refrencePostId
        cardItemID
        postType
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        postCategories {
          nextToken
          __typename
        }
        studentModuleQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        userProfileDetailsPostsId
        __typename
      }
      iSpringID
      moduleCategory
      moduleLevel
      moduleTitle
      moduleGrade
      moduleSeqNo
      questionIndex
      questionText
      totalScore
      schoolName
      schoolLocation
      userAnswer
      creatorEmail
      Status
      correctAnswer
      pointsAllotted
      pointsEarned
      createdAt
      updatedAt
      userProfileDetailsModuleStudentQuestionResultId
      postsStudentModuleQuestionResultId
      __typename
    }
  }
`;
export const createInteractiveQuizUserProfileDetails = /* GraphQL */ `
  mutation CreateInteractiveQuizUserProfileDetails(
    $input: CreateInteractiveQuizUserProfileDetailsInput!
    $condition: ModelInteractiveQuizUserProfileDetailsConditionInput
  ) {
    createInteractiveQuizUserProfileDetails(
      input: $input
      condition: $condition
    ) {
      id
      first_name
      last_name
      mobile_no
      userType
      username
      quizStudent {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentId
          interactiveQuizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInteractiveQuizUserProfileDetails = /* GraphQL */ `
  mutation UpdateInteractiveQuizUserProfileDetails(
    $input: UpdateInteractiveQuizUserProfileDetailsInput!
    $condition: ModelInteractiveQuizUserProfileDetailsConditionInput
  ) {
    updateInteractiveQuizUserProfileDetails(
      input: $input
      condition: $condition
    ) {
      id
      first_name
      last_name
      mobile_no
      userType
      username
      quizStudent {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentId
          interactiveQuizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInteractiveQuizUserProfileDetails = /* GraphQL */ `
  mutation DeleteInteractiveQuizUserProfileDetails(
    $input: DeleteInteractiveQuizUserProfileDetailsInput!
    $condition: ModelInteractiveQuizUserProfileDetailsConditionInput
  ) {
    deleteInteractiveQuizUserProfileDetails(
      input: $input
      condition: $condition
    ) {
      id
      first_name
      last_name
      mobile_no
      userType
      username
      quizStudent {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentId
          interactiveQuizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInteractiveQuizDetails = /* GraphQL */ `
  mutation CreateInteractiveQuizDetails(
    $input: CreateInteractiveQuizDetailsInput!
    $condition: ModelInteractiveQuizDetailsConditionInput
  ) {
    createInteractiveQuizDetails(input: $input, condition: $condition) {
      id
      title
      interest
      subinterest
      level
      creatorEmail
      type
      questions {
        items {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          interactiveQuizDetailsQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      questionTimeLimit
      intimationQuestionText
      quizInstances {
        items {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          interactiveQuizDetailsQuizInstancesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInteractiveQuizDetails = /* GraphQL */ `
  mutation UpdateInteractiveQuizDetails(
    $input: UpdateInteractiveQuizDetailsInput!
    $condition: ModelInteractiveQuizDetailsConditionInput
  ) {
    updateInteractiveQuizDetails(input: $input, condition: $condition) {
      id
      title
      interest
      subinterest
      level
      creatorEmail
      type
      questions {
        items {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          interactiveQuizDetailsQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      questionTimeLimit
      intimationQuestionText
      quizInstances {
        items {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          interactiveQuizDetailsQuizInstancesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInteractiveQuizDetails = /* GraphQL */ `
  mutation DeleteInteractiveQuizDetails(
    $input: DeleteInteractiveQuizDetailsInput!
    $condition: ModelInteractiveQuizDetailsConditionInput
  ) {
    deleteInteractiveQuizDetails(input: $input, condition: $condition) {
      id
      title
      interest
      subinterest
      level
      creatorEmail
      type
      questions {
        items {
          id
          index
          text
          points
          correctAnswer
          createdAt
          updatedAt
          interactiveQuizDetailsQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      questionTimeLimit
      intimationQuestionText
      quizInstances {
        items {
          id
          createdAt
          sendResult
          isResultSent
          resultSendTime
          isStarted
          startTime
          isEnded
          medium
          endTime
          isInstituteBased
          instituteName
          updatedAt
          interactiveQuizDetailsQuizInstancesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInteractiveQuizQuestionOptions = /* GraphQL */ `
  mutation CreateInteractiveQuizQuestionOptions(
    $input: CreateInteractiveQuizQuestionOptionsInput!
    $condition: ModelInteractiveQuizQuestionOptionsConditionInput
  ) {
    createInteractiveQuizQuestionOptions(input: $input, condition: $condition) {
      id
      indexKey
      indexValue
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizQuestionsQuizQuestionOptionsId
      __typename
    }
  }
`;
export const updateInteractiveQuizQuestionOptions = /* GraphQL */ `
  mutation UpdateInteractiveQuizQuestionOptions(
    $input: UpdateInteractiveQuizQuestionOptionsInput!
    $condition: ModelInteractiveQuizQuestionOptionsConditionInput
  ) {
    updateInteractiveQuizQuestionOptions(input: $input, condition: $condition) {
      id
      indexKey
      indexValue
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizQuestionsQuizQuestionOptionsId
      __typename
    }
  }
`;
export const deleteInteractiveQuizQuestionOptions = /* GraphQL */ `
  mutation DeleteInteractiveQuizQuestionOptions(
    $input: DeleteInteractiveQuizQuestionOptionsInput!
    $condition: ModelInteractiveQuizQuestionOptionsConditionInput
  ) {
    deleteInteractiveQuizQuestionOptions(input: $input, condition: $condition) {
      id
      indexKey
      indexValue
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizQuestionsQuizQuestionOptionsId
      __typename
    }
  }
`;
export const createInteractiveQuizQuestions = /* GraphQL */ `
  mutation CreateInteractiveQuizQuestions(
    $input: CreateInteractiveQuizQuestionsInput!
    $condition: ModelInteractiveQuizQuestionsConditionInput
  ) {
    createInteractiveQuizQuestions(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      index
      text
      QuizQuestionOptions {
        items {
          id
          indexKey
          indexValue
          createdAt
          updatedAt
          interactiveQuizQuestionsQuizQuestionOptionsId
          __typename
        }
        nextToken
        __typename
      }
      points
      correctAnswer
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizDetailsQuestionsId
      __typename
    }
  }
`;
export const updateInteractiveQuizQuestions = /* GraphQL */ `
  mutation UpdateInteractiveQuizQuestions(
    $input: UpdateInteractiveQuizQuestionsInput!
    $condition: ModelInteractiveQuizQuestionsConditionInput
  ) {
    updateInteractiveQuizQuestions(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      index
      text
      QuizQuestionOptions {
        items {
          id
          indexKey
          indexValue
          createdAt
          updatedAt
          interactiveQuizQuestionsQuizQuestionOptionsId
          __typename
        }
        nextToken
        __typename
      }
      points
      correctAnswer
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizDetailsQuestionsId
      __typename
    }
  }
`;
export const deleteInteractiveQuizQuestions = /* GraphQL */ `
  mutation DeleteInteractiveQuizQuestions(
    $input: DeleteInteractiveQuizQuestionsInput!
    $condition: ModelInteractiveQuizQuestionsConditionInput
  ) {
    deleteInteractiveQuizQuestions(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      index
      text
      QuizQuestionOptions {
        items {
          id
          indexKey
          indexValue
          createdAt
          updatedAt
          interactiveQuizQuestionsQuizQuestionOptionsId
          __typename
        }
        nextToken
        __typename
      }
      points
      correctAnswer
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizDetailsQuestionsId
      __typename
    }
  }
`;
export const createInteractiveQuizInstance = /* GraphQL */ `
  mutation CreateInteractiveQuizInstance(
    $input: CreateInteractiveQuizInstanceInput!
    $condition: ModelInteractiveQuizInstanceConditionInput
  ) {
    createInteractiveQuizInstance(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      sendResult
      isResultSent
      resultSendTime
      isStarted
      startTime
      isEnded
      medium
      endTime
      isInstituteBased
      instituteName
      quizInstanceStudents {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentId
          interactiveQuizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      interactiveQuizDetailsQuizInstancesId
      __typename
    }
  }
`;
export const updateInteractiveQuizInstance = /* GraphQL */ `
  mutation UpdateInteractiveQuizInstance(
    $input: UpdateInteractiveQuizInstanceInput!
    $condition: ModelInteractiveQuizInstanceConditionInput
  ) {
    updateInteractiveQuizInstance(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      sendResult
      isResultSent
      resultSendTime
      isStarted
      startTime
      isEnded
      medium
      endTime
      isInstituteBased
      instituteName
      quizInstanceStudents {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentId
          interactiveQuizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      interactiveQuizDetailsQuizInstancesId
      __typename
    }
  }
`;
export const deleteInteractiveQuizInstance = /* GraphQL */ `
  mutation DeleteInteractiveQuizInstance(
    $input: DeleteInteractiveQuizInstanceInput!
    $condition: ModelInteractiveQuizInstanceConditionInput
  ) {
    deleteInteractiveQuizInstance(input: $input, condition: $condition) {
      id
      quizDetailId {
        id
        title
        interest
        subinterest
        level
        creatorEmail
        type
        questions {
          nextToken
          __typename
        }
        questionTimeLimit
        intimationQuestionText
        quizInstances {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      sendResult
      isResultSent
      resultSendTime
      isStarted
      startTime
      isEnded
      medium
      endTime
      isInstituteBased
      instituteName
      quizInstanceStudents {
        items {
          id
          isParticipating
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentId
          interactiveQuizInstanceQuizInstanceStudentsId
          __typename
        }
        nextToken
        __typename
      }
      quizStudentQuestionResult {
        items {
          id
          answerReceived
          pointsEarned
          createdAt
          updatedAt
          interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
          interactiveQuizQuestionsQuizStudentQuestionResultId
          interactiveQuizInstanceQuizStudentQuestionResultId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      interactiveQuizDetailsQuizInstancesId
      __typename
    }
  }
`;
export const createInteractiveQuizStudent = /* GraphQL */ `
  mutation CreateInteractiveQuizStudent(
    $input: CreateInteractiveQuizStudentInput!
    $condition: ModelInteractiveQuizStudentConditionInput
  ) {
    createInteractiveQuizStudent(input: $input, condition: $condition) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      isParticipating
      userId {
        id
        first_name
        last_name
        mobile_no
        userType
        username
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizUserProfileDetailsQuizStudentId
      interactiveQuizInstanceQuizInstanceStudentsId
      __typename
    }
  }
`;
export const updateInteractiveQuizStudent = /* GraphQL */ `
  mutation UpdateInteractiveQuizStudent(
    $input: UpdateInteractiveQuizStudentInput!
    $condition: ModelInteractiveQuizStudentConditionInput
  ) {
    updateInteractiveQuizStudent(input: $input, condition: $condition) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      isParticipating
      userId {
        id
        first_name
        last_name
        mobile_no
        userType
        username
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizUserProfileDetailsQuizStudentId
      interactiveQuizInstanceQuizInstanceStudentsId
      __typename
    }
  }
`;
export const deleteInteractiveQuizStudent = /* GraphQL */ `
  mutation DeleteInteractiveQuizStudent(
    $input: DeleteInteractiveQuizStudentInput!
    $condition: ModelInteractiveQuizStudentConditionInput
  ) {
    deleteInteractiveQuizStudent(input: $input, condition: $condition) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      isParticipating
      userId {
        id
        first_name
        last_name
        mobile_no
        userType
        username
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      interactiveQuizUserProfileDetailsQuizStudentId
      interactiveQuizInstanceQuizInstanceStudentsId
      __typename
    }
  }
`;
export const createInteractiveQuizStudentQuestionResult = /* GraphQL */ `
  mutation CreateInteractiveQuizStudentQuestionResult(
    $input: CreateInteractiveQuizStudentQuestionResultInput!
    $condition: ModelInteractiveQuizStudentQuestionResultConditionInput
  ) {
    createInteractiveQuizStudentQuestionResult(
      input: $input
      condition: $condition
    ) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      userId {
        id
        first_name
        last_name
        mobile_no
        userType
        username
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      answerReceived
      pointsEarned
      createdAt
      updatedAt
      interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
      interactiveQuizQuestionsQuizStudentQuestionResultId
      interactiveQuizInstanceQuizStudentQuestionResultId
      __typename
    }
  }
`;
export const updateInteractiveQuizStudentQuestionResult = /* GraphQL */ `
  mutation UpdateInteractiveQuizStudentQuestionResult(
    $input: UpdateInteractiveQuizStudentQuestionResultInput!
    $condition: ModelInteractiveQuizStudentQuestionResultConditionInput
  ) {
    updateInteractiveQuizStudentQuestionResult(
      input: $input
      condition: $condition
    ) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      userId {
        id
        first_name
        last_name
        mobile_no
        userType
        username
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      answerReceived
      pointsEarned
      createdAt
      updatedAt
      interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
      interactiveQuizQuestionsQuizStudentQuestionResultId
      interactiveQuizInstanceQuizStudentQuestionResultId
      __typename
    }
  }
`;
export const deleteInteractiveQuizStudentQuestionResult = /* GraphQL */ `
  mutation DeleteInteractiveQuizStudentQuestionResult(
    $input: DeleteInteractiveQuizStudentQuestionResultInput!
    $condition: ModelInteractiveQuizStudentQuestionResultConditionInput
  ) {
    deleteInteractiveQuizStudentQuestionResult(
      input: $input
      condition: $condition
    ) {
      id
      quizInstanceId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        createdAt
        sendResult
        isResultSent
        resultSendTime
        isStarted
        startTime
        isEnded
        medium
        endTime
        isInstituteBased
        instituteName
        quizInstanceStudents {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        updatedAt
        interactiveQuizDetailsQuizInstancesId
        __typename
      }
      questionId {
        id
        quizDetailId {
          id
          title
          interest
          subinterest
          level
          creatorEmail
          type
          questionTimeLimit
          intimationQuestionText
          createdAt
          updatedAt
          __typename
        }
        index
        text
        QuizQuestionOptions {
          nextToken
          __typename
        }
        points
        correctAnswer
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        interactiveQuizDetailsQuestionsId
        __typename
      }
      userId {
        id
        first_name
        last_name
        mobile_no
        userType
        username
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      answerReceived
      pointsEarned
      createdAt
      updatedAt
      interactiveQuizUserProfileDetailsQuizStudentQuestionResultId
      interactiveQuizQuestionsQuizStudentQuestionResultId
      interactiveQuizInstanceQuizStudentQuestionResultId
      __typename
    }
  }
`;
export const createUserConnections = /* GraphQL */ `
  mutation CreateUserConnections(
    $input: CreateUserConnectionsInput!
    $condition: ModelUserConnectionsConditionInput
  ) {
    createUserConnections(input: $input, condition: $condition) {
      id
      userProfileDetailsId
      connectionId
      userProfileDetails {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      connection {
        id
        tag
        users {
          nextToken
          __typename
        }
        tags {
          id
          tag_name
          type
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tagMasterTagConnectId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserConnections = /* GraphQL */ `
  mutation UpdateUserConnections(
    $input: UpdateUserConnectionsInput!
    $condition: ModelUserConnectionsConditionInput
  ) {
    updateUserConnections(input: $input, condition: $condition) {
      id
      userProfileDetailsId
      connectionId
      userProfileDetails {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      connection {
        id
        tag
        users {
          nextToken
          __typename
        }
        tags {
          id
          tag_name
          type
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        tagMasterTagConnectId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserConnections = /* GraphQL */ `
  mutation DeleteUserConnections(
    $input: DeleteUserConnectionsInput!
    $condition: ModelUserConnectionsConditionInput
  ) {
    deleteUserConnections(input: $input, condition: $condition) {
      id
      userProfileDetailsId
      connectionId
      userProfileDetails {
        userID {
          email
          id
          isParent
          showPopup
          registerBy
          password
          status
          myfeedTour
          profileTour
          cvTour
          projectTour
          disabled
          registeredDate
          auth_method
          createdAt
          updatedAt
          __typename
        }
        about_me
        about_restriction
        bg_image
        career_goal
        city
        cnt_views
        cv_data
        country
        cvs
        dob
        first_name
        gender
        id
        job
        languages
        last_name
        links
        loginAt
        middle_name
        mobile_no
        parent_email
        parent_mobile
        parent_name
        profile_avatar
        profile_complition
        profile_image
        projects
        projects_data
        referralCode
        school_name
        accomplishment_data
        connection_data
        skipMobileVerification
        skipParentalconsent
        isMobileVerified
        isParentVerified
        isSelfEmailVerified
        isparentRequestSent
        mobileSmsTriggerCnt
        selfEmailTriggerCnt
        parentRequestSentTriggerCnt
        welcomeEmailSentCnt
        mobileSmsTriggerDt
        selfEmailTriggerDt
        parentRequestSentTriggerDt
        welcomeEmailSentDt
        mobileReminderSmsTriggerCnt
        mobileReminderSmsTriggerDt
        mobileCountrycode
        parentmobileCountrycode
        isTestUser
        source
        isAdmin
        adminSchoolName
        adminCompanyName
        adminIssuingOrganisation
        adminAccomplishmentsProvider
        adminMembershipOrganisation
        adminLogo
        state
        tblrolemappingID
        userProfileDetailsUserMasterId
        userType
        username
        UserCards {
          nextToken
          __typename
        }
        UserCvs {
          nextToken
          __typename
        }
        connections {
          nextToken
          __typename
        }
        notifications {
          nextToken
          __typename
        }
        userActivity {
          nextToken
          __typename
        }
        posts {
          nextToken
          __typename
        }
        comments {
          nextToken
          __typename
        }
        CommentOne {
          nextToken
          __typename
        }
        likes {
          nextToken
          __typename
        }
        views {
          nextToken
          __typename
        }
        quizResults {
          nextToken
          __typename
        }
        registeredDate
        adminSchoolType
        quizAvgScore
        interests {
          nextToken
          __typename
        }
        subinterests {
          nextToken
          __typename
        }
        quizStudent {
          nextToken
          __typename
        }
        quizStudentQuestionResult {
          nextToken
          __typename
        }
        moduleStudentQuestionResult {
          nextToken
          __typename
        }
        connectedInstituteAdmins
        createdAt
        updatedAt
        userMasterUserProfileDetailsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGroupSchool = /* GraphQL */ `
  mutation CreateGroupSchool(
    $input: CreateGroupSchoolInput!
    $condition: ModelGroupSchoolConditionInput
  ) {
    createGroupSchool(input: $input, condition: $condition) {
      id
      name
      group_school_admin_email
      contact_number
      unique_code
      schools {
        items {
          id
          name
          school_admin_email
          location
          board
          teachers
          group_school_unique_code
          package_selected
          unique_code
          current_academic_year_start
          current_academic_year_end
          academic_years_count
          teacher_count
          student_count
          course_count
          contact_number
          createdAt
          updatedAt
          groupSchoolSchoolsId
          __typename
        }
        nextToken
        __typename
      }
      schools_count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGroupSchool = /* GraphQL */ `
  mutation UpdateGroupSchool(
    $input: UpdateGroupSchoolInput!
    $condition: ModelGroupSchoolConditionInput
  ) {
    updateGroupSchool(input: $input, condition: $condition) {
      id
      name
      group_school_admin_email
      contact_number
      unique_code
      schools {
        items {
          id
          name
          school_admin_email
          location
          board
          teachers
          group_school_unique_code
          package_selected
          unique_code
          current_academic_year_start
          current_academic_year_end
          academic_years_count
          teacher_count
          student_count
          course_count
          contact_number
          createdAt
          updatedAt
          groupSchoolSchoolsId
          __typename
        }
        nextToken
        __typename
      }
      schools_count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGroupSchool = /* GraphQL */ `
  mutation DeleteGroupSchool(
    $input: DeleteGroupSchoolInput!
    $condition: ModelGroupSchoolConditionInput
  ) {
    deleteGroupSchool(input: $input, condition: $condition) {
      id
      name
      group_school_admin_email
      contact_number
      unique_code
      schools {
        items {
          id
          name
          school_admin_email
          location
          board
          teachers
          group_school_unique_code
          package_selected
          unique_code
          current_academic_year_start
          current_academic_year_end
          academic_years_count
          teacher_count
          student_count
          course_count
          contact_number
          createdAt
          updatedAt
          groupSchoolSchoolsId
          __typename
        }
        nextToken
        __typename
      }
      schools_count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createChildSchool = /* GraphQL */ `
  mutation CreateChildSchool(
    $input: CreateChildSchoolInput!
    $condition: ModelChildSchoolConditionInput
  ) {
    createChildSchool(input: $input, condition: $condition) {
      id
      name
      school_admin_email
      location
      board
      teachers
      group_school_unique_code
      group_school_id {
        id
        name
        group_school_admin_email
        contact_number
        unique_code
        schools {
          nextToken
          __typename
        }
        schools_count
        createdAt
        updatedAt
        __typename
      }
      package_selected
      unique_code
      current_academic_year_start
      current_academic_year_end
      academic_years_count
      teacher_count
      student_count
      course_count
      contact_number
      createdAt
      updatedAt
      groupSchoolSchoolsId
      __typename
    }
  }
`;
export const updateChildSchool = /* GraphQL */ `
  mutation UpdateChildSchool(
    $input: UpdateChildSchoolInput!
    $condition: ModelChildSchoolConditionInput
  ) {
    updateChildSchool(input: $input, condition: $condition) {
      id
      name
      school_admin_email
      location
      board
      teachers
      group_school_unique_code
      group_school_id {
        id
        name
        group_school_admin_email
        contact_number
        unique_code
        schools {
          nextToken
          __typename
        }
        schools_count
        createdAt
        updatedAt
        __typename
      }
      package_selected
      unique_code
      current_academic_year_start
      current_academic_year_end
      academic_years_count
      teacher_count
      student_count
      course_count
      contact_number
      createdAt
      updatedAt
      groupSchoolSchoolsId
      __typename
    }
  }
`;
export const deleteChildSchool = /* GraphQL */ `
  mutation DeleteChildSchool(
    $input: DeleteChildSchoolInput!
    $condition: ModelChildSchoolConditionInput
  ) {
    deleteChildSchool(input: $input, condition: $condition) {
      id
      name
      school_admin_email
      location
      board
      teachers
      group_school_unique_code
      group_school_id {
        id
        name
        group_school_admin_email
        contact_number
        unique_code
        schools {
          nextToken
          __typename
        }
        schools_count
        createdAt
        updatedAt
        __typename
      }
      package_selected
      unique_code
      current_academic_year_start
      current_academic_year_end
      academic_years_count
      teacher_count
      student_count
      course_count
      contact_number
      createdAt
      updatedAt
      groupSchoolSchoolsId
      __typename
    }
  }
`;
export const createSchoolCourses = /* GraphQL */ `
  mutation CreateSchoolCourses(
    $input: CreateSchoolCoursesInput!
    $condition: ModelSchoolCoursesConditionInput
  ) {
    createSchoolCourses(input: $input, condition: $condition) {
      id
      moodle_course_id
      school_unique_id
      grade
      subject
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSchoolCourses = /* GraphQL */ `
  mutation UpdateSchoolCourses(
    $input: UpdateSchoolCoursesInput!
    $condition: ModelSchoolCoursesConditionInput
  ) {
    updateSchoolCourses(input: $input, condition: $condition) {
      id
      moodle_course_id
      school_unique_id
      grade
      subject
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSchoolCourses = /* GraphQL */ `
  mutation DeleteSchoolCourses(
    $input: DeleteSchoolCoursesInput!
    $condition: ModelSchoolCoursesConditionInput
  ) {
    deleteSchoolCourses(input: $input, condition: $condition) {
      id
      moodle_course_id
      school_unique_id
      grade
      subject
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCohort = /* GraphQL */ `
  mutation CreateCohort(
    $input: CreateCohortInput!
    $condition: ModelCohortConditionInput
  ) {
    createCohort(input: $input, condition: $condition) {
      id
      name
      moodle_course_id
      students
      teacher_email
      moodle_cohort_id
      school_unique_id
      grade
      subject
      class
      subClass
      interest
      sub_interest
      current_academic_year_start
      current_academic_year_end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCohort = /* GraphQL */ `
  mutation UpdateCohort(
    $input: UpdateCohortInput!
    $condition: ModelCohortConditionInput
  ) {
    updateCohort(input: $input, condition: $condition) {
      id
      name
      moodle_course_id
      students
      teacher_email
      moodle_cohort_id
      school_unique_id
      grade
      subject
      class
      subClass
      interest
      sub_interest
      current_academic_year_start
      current_academic_year_end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCohort = /* GraphQL */ `
  mutation DeleteCohort(
    $input: DeleteCohortInput!
    $condition: ModelCohortConditionInput
  ) {
    deleteCohort(input: $input, condition: $condition) {
      id
      name
      moodle_course_id
      students
      teacher_email
      moodle_cohort_id
      school_unique_id
      grade
      subject
      class
      subClass
      interest
      sub_interest
      current_academic_year_start
      current_academic_year_end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAssessment = /* GraphQL */ `
  mutation CreateAssessment(
    $input: CreateAssessmentInput!
    $condition: ModelAssessmentConditionInput
  ) {
    createAssessment(input: $input, condition: $condition) {
      id
      moodle_assessment_id
      moodle_master_course_id
      moodle_master_section_id
      moodle_master_fullcode
      assessment_name
      subject
      grade
      file_url
      url
      is_public
      is_disabled_by_super_admin
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAssessment = /* GraphQL */ `
  mutation UpdateAssessment(
    $input: UpdateAssessmentInput!
    $condition: ModelAssessmentConditionInput
  ) {
    updateAssessment(input: $input, condition: $condition) {
      id
      moodle_assessment_id
      moodle_master_course_id
      moodle_master_section_id
      moodle_master_fullcode
      assessment_name
      subject
      grade
      file_url
      url
      is_public
      is_disabled_by_super_admin
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAssessment = /* GraphQL */ `
  mutation DeleteAssessment(
    $input: DeleteAssessmentInput!
    $condition: ModelAssessmentConditionInput
  ) {
    deleteAssessment(input: $input, condition: $condition) {
      id
      moodle_assessment_id
      moodle_master_course_id
      moodle_master_section_id
      moodle_master_fullcode
      assessment_name
      subject
      grade
      file_url
      url
      is_public
      is_disabled_by_super_admin
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAssessmentInstance = /* GraphQL */ `
  mutation CreateAssessmentInstance(
    $input: CreateAssessmentInstanceInput!
    $condition: ModelAssessmentInstanceConditionInput
  ) {
    createAssessmentInstance(input: $input, condition: $condition) {
      id
      start_time
      end_time
      cohort_id
      students
      teacher_email
      status
      term
      attempt_limit
      is_report_sent
      assessment_id {
        id
        moodle_assessment_id
        moodle_master_course_id
        moodle_master_section_id
        moodle_master_fullcode
        assessment_name
        subject
        grade
        file_url
        url
        is_public
        is_disabled_by_super_admin
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      assessmentInstancesId
      __typename
    }
  }
`;
export const updateAssessmentInstance = /* GraphQL */ `
  mutation UpdateAssessmentInstance(
    $input: UpdateAssessmentInstanceInput!
    $condition: ModelAssessmentInstanceConditionInput
  ) {
    updateAssessmentInstance(input: $input, condition: $condition) {
      id
      start_time
      end_time
      cohort_id
      students
      teacher_email
      status
      term
      attempt_limit
      is_report_sent
      assessment_id {
        id
        moodle_assessment_id
        moodle_master_course_id
        moodle_master_section_id
        moodle_master_fullcode
        assessment_name
        subject
        grade
        file_url
        url
        is_public
        is_disabled_by_super_admin
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      assessmentInstancesId
      __typename
    }
  }
`;
export const deleteAssessmentInstance = /* GraphQL */ `
  mutation DeleteAssessmentInstance(
    $input: DeleteAssessmentInstanceInput!
    $condition: ModelAssessmentInstanceConditionInput
  ) {
    deleteAssessmentInstance(input: $input, condition: $condition) {
      id
      start_time
      end_time
      cohort_id
      students
      teacher_email
      status
      term
      attempt_limit
      is_report_sent
      assessment_id {
        id
        moodle_assessment_id
        moodle_master_course_id
        moodle_master_section_id
        moodle_master_fullcode
        assessment_name
        subject
        grade
        file_url
        url
        is_public
        is_disabled_by_super_admin
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      assessmentInstancesId
      __typename
    }
  }
`;
export const createAssessmentResponse = /* GraphQL */ `
  mutation CreateAssessmentResponse(
    $input: CreateAssessmentResponseInput!
    $condition: ModelAssessmentResponseConditionInput
  ) {
    createAssessmentResponse(input: $input, condition: $condition) {
      id
      assessment_instance_id
      total_score
      result
      score
      student_id
      student_email
      attempt_count
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAssessmentResponse = /* GraphQL */ `
  mutation UpdateAssessmentResponse(
    $input: UpdateAssessmentResponseInput!
    $condition: ModelAssessmentResponseConditionInput
  ) {
    updateAssessmentResponse(input: $input, condition: $condition) {
      id
      assessment_instance_id
      total_score
      result
      score
      student_id
      student_email
      attempt_count
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAssessmentResponse = /* GraphQL */ `
  mutation DeleteAssessmentResponse(
    $input: DeleteAssessmentResponseInput!
    $condition: ModelAssessmentResponseConditionInput
  ) {
    deleteAssessmentResponse(input: $input, condition: $condition) {
      id
      assessment_instance_id
      total_score
      result
      score
      student_id
      student_email
      attempt_count
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSkills = /* GraphQL */ `
  mutation CreateSkills(
    $input: CreateSkillsInput!
    $condition: ModelSkillsConditionInput
  ) {
    createSkills(input: $input, condition: $condition) {
      id
      name
      headline
      title
      description
      interest
      subinterest
      tag
      levels
      level_details
      newData
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSkills = /* GraphQL */ `
  mutation UpdateSkills(
    $input: UpdateSkillsInput!
    $condition: ModelSkillsConditionInput
  ) {
    updateSkills(input: $input, condition: $condition) {
      id
      name
      headline
      title
      description
      interest
      subinterest
      tag
      levels
      level_details
      newData
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSkills = /* GraphQL */ `
  mutation DeleteSkills(
    $input: DeleteSkillsInput!
    $condition: ModelSkillsConditionInput
  ) {
    deleteSkills(input: $input, condition: $condition) {
      id
      name
      headline
      title
      description
      interest
      subinterest
      tag
      levels
      level_details
      newData
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMasterSkill = /* GraphQL */ `
  mutation CreateMasterSkill(
    $input: CreateMasterSkillInput!
    $condition: ModelMasterSkillConditionInput
  ) {
    createMasterSkill(input: $input, condition: $condition) {
      id
      name
      interest
      subinterest
      tag
      variants {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMasterSkill = /* GraphQL */ `
  mutation UpdateMasterSkill(
    $input: UpdateMasterSkillInput!
    $condition: ModelMasterSkillConditionInput
  ) {
    updateMasterSkill(input: $input, condition: $condition) {
      id
      name
      interest
      subinterest
      tag
      variants {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMasterSkill = /* GraphQL */ `
  mutation DeleteMasterSkill(
    $input: DeleteMasterSkillInput!
    $condition: ModelMasterSkillConditionInput
  ) {
    deleteMasterSkill(input: $input, condition: $condition) {
      id
      name
      interest
      subinterest
      tag
      variants {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createVariantSkill = /* GraphQL */ `
  mutation CreateVariantSkill(
    $input: CreateVariantSkillInput!
    $condition: ModelVariantSkillConditionInput
  ) {
    createVariantSkill(input: $input, condition: $condition) {
      id
      variant_type
      variant_id
      variant_grade
      cohort_id
      name
      description
      level_count
      level_detail
      master_skill_id {
        id
        name
        interest
        subinterest
        tag
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      masterSkillVariantsId
      __typename
    }
  }
`;
export const updateVariantSkill = /* GraphQL */ `
  mutation UpdateVariantSkill(
    $input: UpdateVariantSkillInput!
    $condition: ModelVariantSkillConditionInput
  ) {
    updateVariantSkill(input: $input, condition: $condition) {
      id
      variant_type
      variant_id
      variant_grade
      cohort_id
      name
      description
      level_count
      level_detail
      master_skill_id {
        id
        name
        interest
        subinterest
        tag
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      masterSkillVariantsId
      __typename
    }
  }
`;
export const deleteVariantSkill = /* GraphQL */ `
  mutation DeleteVariantSkill(
    $input: DeleteVariantSkillInput!
    $condition: ModelVariantSkillConditionInput
  ) {
    deleteVariantSkill(input: $input, condition: $condition) {
      id
      variant_type
      variant_id
      variant_grade
      cohort_id
      name
      description
      level_count
      level_detail
      master_skill_id {
        id
        name
        interest
        subinterest
        tag
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      masterSkillVariantsId
      __typename
    }
  }
`;
export const createCompetitionCategory = /* GraphQL */ `
  mutation CreateCompetitionCategory(
    $input: CreateCompetitionCategoryInput!
    $condition: ModelCompetitionCategoryConditionInput
  ) {
    createCompetitionCategory(input: $input, condition: $condition) {
      id
      code_type
      code_value
      category_name
      category_slug
      description
      start_date
      end_date
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCompetitionCategory = /* GraphQL */ `
  mutation UpdateCompetitionCategory(
    $input: UpdateCompetitionCategoryInput!
    $condition: ModelCompetitionCategoryConditionInput
  ) {
    updateCompetitionCategory(input: $input, condition: $condition) {
      id
      code_type
      code_value
      category_name
      category_slug
      description
      start_date
      end_date
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCompetitionCategory = /* GraphQL */ `
  mutation DeleteCompetitionCategory(
    $input: DeleteCompetitionCategoryInput!
    $condition: ModelCompetitionCategoryConditionInput
  ) {
    deleteCompetitionCategory(input: $input, condition: $condition) {
      id
      code_type
      code_value
      category_name
      category_slug
      description
      start_date
      end_date
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCompetitionScore = /* GraphQL */ `
  mutation CreateCompetitionScore(
    $input: CreateCompetitionScoreInput!
    $condition: ModelCompetitionScoreConditionInput
  ) {
    createCompetitionScore(input: $input, condition: $condition) {
      id
      competition_category_id
      score
      user_id
      post_id
      grader
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCompetitionScore = /* GraphQL */ `
  mutation UpdateCompetitionScore(
    $input: UpdateCompetitionScoreInput!
    $condition: ModelCompetitionScoreConditionInput
  ) {
    updateCompetitionScore(input: $input, condition: $condition) {
      id
      competition_category_id
      score
      user_id
      post_id
      grader
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCompetitionScore = /* GraphQL */ `
  mutation DeleteCompetitionScore(
    $input: DeleteCompetitionScoreInput!
    $condition: ModelCompetitionScoreConditionInput
  ) {
    deleteCompetitionScore(input: $input, condition: $condition) {
      id
      competition_category_id
      score
      user_id
      post_id
      grader
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPostCompetitionCategories = /* GraphQL */ `
  mutation CreatePostCompetitionCategories(
    $input: CreatePostCompetitionCategoriesInput!
    $condition: ModelPostCompetitionCategoriesConditionInput
  ) {
    createPostCompetitionCategories(input: $input, condition: $condition) {
      id
      post_id
      is_graded
      competition_category_id
      competition_category_slug
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePostCompetitionCategories = /* GraphQL */ `
  mutation UpdatePostCompetitionCategories(
    $input: UpdatePostCompetitionCategoriesInput!
    $condition: ModelPostCompetitionCategoriesConditionInput
  ) {
    updatePostCompetitionCategories(input: $input, condition: $condition) {
      id
      post_id
      is_graded
      competition_category_id
      competition_category_slug
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePostCompetitionCategories = /* GraphQL */ `
  mutation DeletePostCompetitionCategories(
    $input: DeletePostCompetitionCategoriesInput!
    $condition: ModelPostCompetitionCategoriesConditionInput
  ) {
    deletePostCompetitionCategories(input: $input, condition: $condition) {
      id
      post_id
      is_graded
      competition_category_id
      competition_category_slug
      createdAt
      updatedAt
      __typename
    }
  }
`;